const socialstudiesQuestions = [
    {
      "question": "What is self-identity? (v1)",
      "options": [
        "Knowing your name",
        "Understanding who you are",
        "Being famous",
        "Being rich"
      ],
      "answer": "Understanding who you are"
    },
  {
    "question": "What is the importance of peace building in a community?",
    "options": [
      "To encourage conflicts",
      "To promote harmony and unity",
      "To ignore disagreements",
      "To weaken leaders"
    ],
    "answer": "To promote harmony and unity"
  },
  {
    "question": "Who is a good follower in governance?",
    "options": [
      "Someone who blindly obeys",
      "Someone who challenges authority without cause",
      "Someone who supports good leadership and laws",
      "Someone who never participates"
    ],
    "answer": "Someone who supports good leadership and laws"
  },
  {
    "question": "What is the Constitution of Ghana?",
    "options": [
      "A religious text",
      "A school syllabus",
      "A set of laws governing the country",
      "A political party's agenda"
    ],
    "answer": "A set of laws governing the country"
  },
  {
    "question": "Which of the following is a right of the individual?",
    "options": [
      "Right to destroy property",
      "Right to vote",
      "Right to break laws",
      "Right to avoid taxes"
    ],
    "answer": "Right to vote"
  },
  {
    "question": "How does Ghana benefit from being in the international community?",
    "options": [
      "By isolating from others",
      "By receiving support and trade opportunities",
      "By banning tourism",
      "By limiting education"
    ],
    "answer": "By receiving support and trade opportunities"
  },
  {
    "question": "How can the youth contribute to national development?",
    "options": [
      "Avoiding education",
      "Engaging in nation-building activities",
      "Rejecting hard work",
      "Waiting for handouts"
    ],
    "answer": "Engaging in nation-building activities"
  },
  {
    "question": "What is one major benefit of science and technology?",
    "options": [
      "Causing pollution",
      "Promoting superstition",
      "Driving innovation and development",
      "Discouraging research"
    ],
    "answer": "Driving innovation and development"
  },
  {
    "question": "What is resource utilization?",
    "options": [
      "Wasting resources",
      "Using natural resources efficiently",
      "Ignoring natural resources",
      "Exporting all resources"
    ],
    "answer": "Using natural resources efficiently"
  },
  {
    "question": "What role does an individual play in community development?",
    "options": [
      "Destroying public facilities",
      "Helping solve local problems",
      "Avoiding local projects",
      "Rejecting communal work"
    ],
    "answer": "Helping solve local problems"
  },
  {
    "question": "Which of the following promotes socio-economic development?",
    "options": [
      "Corruption",
      "Infrastructure development",
      "Neglecting education",
      "Political violence"
    ],
    "answer": "Infrastructure development"
  },
  {
    "question": "What is the aim of sustainable development?",
    "options": [
      "To exploit resources fully",
      "To balance development with environmental protection",
      "To ignore future generations",
      "To promote short-term gains only"
    ],
    "answer": "To balance development with environmental protection"
  },
  {
    "question": "What effect does rapid population growth have?",
    "options": [
      "More job opportunities",
      "Strain on social services",
      "Less housing problems",
      "Decreased demand for food"
    ],
    "answer": "Strain on social services"
  },
  {
    "question": "What does entrepreneurship involve?",
    "options": [
      "Depending on others for jobs",
      "Creating and managing a business",
      "Avoiding financial risks",
      "Ignoring opportunities"
    ],
    "answer": "Creating and managing a business"
  },
  {
    "question": "What is the purpose of adolescent reproductive health education?",
    "options": [
      "To promote early pregnancies",
      "To support harmful practices",
      "To prevent risky behaviors",
      "To reduce awareness"
    ],
    "answer": "To prevent risky behaviors"
  },
  {
    "question": "Which is a key feature of responsible parenting?",
    "options": [
      "Providing no rules",
      "Giving care and supervision",
      "Being absent always",
      "Encouraging bad habits"
    ],
    "answer": "Giving care and supervision"
  },
  {
    "question": "Which of these contributes to national identity?",
    "options": [
      "Ignoring customs",
      "Celebrating local festivals",
      "Rejecting your language",
      "Forgetting history"
    ],
    "answer": "Celebrating local festivals"
  },
  {
    "question": "How can conflicts be resolved peacefully?",
    "options": [
      "Using violence",
      "Through dialogue and negotiation",
      "Avoiding communication",
      "Ignoring the issue"
    ],
    "answer": "Through dialogue and negotiation"
  },
  {
    "question": "What is a basic responsibility of a citizen?",
    "options": [
      "Disobeying laws",
      "Paying taxes",
      "Avoiding civic duties",
      "Spreading misinformation"
    ],
    "answer": "Paying taxes"
  },
  {
    "question": "What is national self-reliance?",
    "options": [
      "Depending on foreign aid",
      "Building a nation�s own capacity",
      "Avoiding local products",
      "Blocking local industries"
    ],
    "answer": "Building a nation�s own capacity"
  },
  {
    "question": "What does socialization help children learn?",
    "options": [
      "Wrong behaviors",
      "Societal values and norms",
      "How to fight",
      "How to live alone"
    ],
    "answer": "Societal values and norms"
  },
  {
    "question": "What is the significance of festivals in Ghanaian culture?",
    "options": [
      "They waste time",
      "They promote cultural heritage and unity",
      "They discourage education",
      "They cause division"
    ],
    "answer": "They promote cultural heritage and unity"
  },
  {
    "question": "Which of these is a sign of responsible youth?",
    "options": [
      "Engaging in armed robbery",
      "Participating in community service",
      "Dropping out of school",
      "Avoiding responsibilities"
    ],
    "answer": "Participating in community service"
  },
  {
    "question": "What is the main reason for promoting family unity?",
    "options": [
      "To reduce cooperation",
      "To strengthen family support systems",
      "To create rivalry",
      "To encourage disrespect"
    ],
    "answer": "To strengthen family support systems"
  },
  {
    "question": "Which of the following is a negative impact of improper waste disposal?",
    "options": [
      "Cleaner environment",
      "Flooding and disease outbreaks",
      "Economic growth",
      "Better health"
    ],
    "answer": "Flooding and disease outbreaks"
  },
  {
    "question": "Which document guarantees human rights in Ghana?",
    "options": [
      "The Bible",
      "The 1992 Constitution",
      "The School Rules",
      "The National Anthem"
    ],
    "answer": "The 1992 Constitution"
  },
  {
    "question": "Why is it important to respect other people's rights?",
    "options": [
      "To avoid punishment",
      "To promote peace and coexistence",
      "To show power",
      "To control others"
    ],
    "answer": "To promote peace and coexistence"
  },
  {
    "question": "How can technology improve farming in Ghana?",
    "options": [
      "By reducing productivity",
      "By introducing modern tools and techniques",
      "By encouraging bush burning",
      "By destroying soil fertility"
    ],
    "answer": "By introducing modern tools and techniques"
  },
  {
    "question": "Which of these is a social responsibility?",
    "options": [
      "Obeying traffic rules",
      "Avoiding school",
      "Disobeying elders",
      "Littering the streets"
    ],
    "answer": "Obeying traffic rules"
  },
  {
    "question": "What is the role of the Electoral Commission in Ghana?",
    "options": [
      "To make laws",
      "To conduct free and fair elections",
      "To rule the country",
      "To appoint ministers"
    ],
    "answer": "To conduct free and fair elections"
  },
  {
    "question": "Why is sustainable resource use important?",
    "options": [
      "To destroy resources quickly",
      "To meet current and future needs",
      "To exploit natural wealth rapidly",
      "To satisfy only one generation"
    ],
    "answer": "To meet current and future needs"
  },
  {
    "question": "Which of the following best describes leadership?",
    "options": [
      "Using force to control others",
      "Guiding and inspiring others toward a common goal",
      "Avoiding responsibility",
      "Serving oneself only"
    ],
    "answer": "Guiding and inspiring others toward a common goal"
  },
  {
    "question": "How can education reduce poverty?",
    "options": [
      "By making people lazy",
      "By encouraging dependency",
      "By providing skills for employment",
      "By wasting resources"
    ],
    "answer": "By providing skills for employment"
  },
  {
    "question": "What is the world of work?",
    "options": [
      "A place to sleep",
      "The environment where people apply their skills for income",
      "A place of leisure",
      "A center for gossip"
    ],
    "answer": "The environment where people apply their skills for income"
  },
  {
    "question": "What is one key benefit of entrepreneurship?",
    "options": [
      "Increasing unemployment",
      "Creating jobs and innovation",
      "Avoiding taxes",
      "Limiting growth"
    ],
    "answer": "Creating jobs and innovation"
  },
  {
    "question": "Which of these is a way of showing national pride?",
    "options": [
      "Disrespecting the national anthem",
      "Flying the national flag",
      "Ignoring national holidays",
      "Mocking leaders"
    ],
    "answer": "Flying the national flag"
  },
  {
    "question": "Which practice promotes responsible environmental behavior?",
    "options": [
      "Illegal mining",
      "Afforestation",
      "Littering",
      "Bush burning"
    ],
    "answer": "Afforestation"
  },
  {
    "question": "What is one effect of teenage pregnancy?",
    "options": [
      "Higher school completion rates",
      "Educational disruption",
      "More job opportunities",
      "Improved academic performance"
    ],
    "answer": "Educational disruption"
  },
  {
    "question": "What is the benefit of effective communication in a family?",
    "options": [
      "Misunderstanding",
      "Building stronger relationships",
      "Increased tension",
      "Isolation"
    ],
    "answer": "Building stronger relationships"
  },
  {
    "question": "Which is a symbol of Ghana�s national identity?",
    "options": [
      "The Eiffel Tower",
      "The Black Star",
      "The Great Wall",
      "The Taj Mahal"
    ],
    "answer": "The Black Star"
  },
  {
    "question": "Which of the following is a moral value taught in the family?",
    "options": [
      "Selfishness",
      "Respect for elders",
      "Dishonesty",
      "Disobedience"
    ],
    "answer": "Respect for elders"
  },
  {
    "question": "What is the function of the judiciary in Ghana?",
    "options": [
      "To make laws",
      "To interpret and apply the law",
      "To create political parties",
      "To organize elections"
    ],
    "answer": "To interpret and apply the law"
  },
  {
    "question": "Which of the following is a result of illegal mining (galamsey)?",
    "options": [
      "Clean water supply",
      "Environmental degradation",
      "Forest protection",
      "Increased tourism"
    ],
    "answer": "Environmental degradation"
  },
  {
    "question": "What is meant by �followership� in governance?",
    "options": [
      "Blind obedience to leaders",
      "The role of citizens in supporting or challenging leadership",
      "Only attending political rallies",
      "Joining political parties"
    ],
    "answer": "The role of citizens in supporting or challenging leadership"
  },
  {
    "question": "How does population growth affect the economy?",
    "options": [
      "Lowers demand for food",
      "Reduces unemployment",
      "Increases pressure on resources",
      "Improves housing conditions"
    ],
    "answer": "Increases pressure on resources"
  },
  {
    "question": "What is cultural integration?",
    "options": [
      "Forcing everyone to abandon culture",
      "Bringing different cultures together in harmony",
      "Rejecting traditional practices",
      "Promoting only one culture"
    ],
    "answer": "Bringing different cultures together in harmony"
  },
  {
    "question": "Which of these is an example of good leadership?",
    "options": [
      "Stealing public funds",
      "Serving the people selflessly",
      "Ignoring laws",
      "Favoring relatives"
    ],
    "answer": "Serving the people selflessly"
  },
  {
    "question": "Why should citizens obey laws?",
    "options": [
      "To avoid being mocked",
      "To maintain peace and order",
      "To impress others",
      "To become famous"
    ],
    "answer": "To maintain peace and order"
  },
  {
    "question": "Which of the following is a method of conflict resolution?",
    "options": [
      "Retaliation",
      "Violence",
      "Peaceful dialogue",
      "Destruction of property"
    ],
    "answer": "Peaceful dialogue"
  },
  {
    "question": "Which of these best supports national development?",
    "options": [
      "Civic irresponsibility",
      "Corruption",
      "Transparency and accountability",
      "Ethnic discrimination"
    ],
    "answer": "Transparency and accountability"
  },
  {
    "question": "What is the role of customs and traditions in society?",
    "options": [
      "To destroy culture",
      "To preserve identity and heritage",
      "To promote ignorance",
      "To cause conflict"
    ],
    "answer": "To preserve identity and heritage"
  },
  {
    "question": "How does responsible parenting influence society?",
    "options": [
      "Encourages child neglect",
      "Produces disciplined and productive citizens",
      "Promotes streetism",
      "Discourages education"
    ],
    "answer": "Produces disciplined and productive citizens"
  },
  {
    "question": "What is a civic responsibility of a student?",
    "options": [
      "Cheating in exams",
      "Vandalizing school property",
      "Respecting rules and elders",
      "Avoiding school duties"
    ],
    "answer": "Respecting rules and elders"
  },
  {
    "question": "Which of these is an example of a national symbol?",
    "options": [
      "The school bell",
      "The Ghana Coat of Arms",
      "A church logo",
      "A foreign flag"
    ],
    "answer": "The Ghana Coat of Arms"
  },
  {
    "question": "Why is cooperation important in the family?",
    "options": [
      "It creates conflict",
      "It leads to separation",
      "It promotes unity and shared responsibilities",
      "It encourages laziness"
    ],
    "answer": "It promotes unity and shared responsibilities"
  },
  {
    "question": "Which of these promotes environmental sustainability?",
    "options": [
      "Open defecation",
      "Illegal dumping",
      "Recycling waste",
      "Deforestation"
    ],
    "answer": "Recycling waste"
  },
  {
    "question": "What is one cause of rural-urban migration?",
    "options": [
      "Abundant rural jobs",
      "Poor education in cities",
      "Search for better living conditions",
      "Low cost of living in rural areas"
    ],
    "answer": "Search for better living conditions"
  },
  {
    "question": "What is a benefit of cultural festivals?",
    "options": [
      "Promoting foreign culture",
      "Destroying traditions",
      "Educating the youth about heritage",
      "Causing public disorder"
    ],
    "answer": "Educating the youth about heritage"
  },
  {
    "question": "Which of these is a negative social behavior?",
    "options": [
      "Volunteering",
      "Truancy",
      "Respecting rules",
      "Helping others"
    ],
    "answer": "Truancy"
  },
  {
    "question": "What is one role of students in community development?",
    "options": [
      "Avoiding communal labor",
      "Participating in clean-up exercises",
      "Destroying school property",
      "Ignoring school clubs"
    ],
    "answer": "Participating in clean-up exercises"
  },
  {
    "question": "What is the role of education in personal development?",
    "options": [
      "Promotes laziness",
      "Helps individuals acquire knowledge and skills",
      "Reduces productivity",
      "Discourages innovation"
    ],
    "answer": "Helps individuals acquire knowledge and skills"
  },
  {
    "question": "How does science and technology contribute to national development?",
    "options": [
      "By increasing ignorance",
      "By delaying innovation",
      "By improving infrastructure and services",
      "By encouraging laziness"
    ],
    "answer": "By improving infrastructure and services"
  },
  {
    "question": "Which of the following is an effect of irresponsible sexual behavior?",
    "options": [
      "Academic success",
      "HIV and other STIs",
      "Improved relationships",
      "Respect from peers"
    ],
    "answer": "HIV and other STIs"
  },
  {
    "question": "What is the importance of national independence?",
    "options": [
      "Foreign domination",
      "Self-governance and pride",
      "Colonial rule",
      "Loss of identity"
    ],
    "answer": "Self-governance and pride"
  },
  {
    "question": "Which of the following promotes peaceful coexistence?",
    "options": [
      "Tolerance and dialogue",
      "Revenge and hatred",
      "Intolerance",
      "Gossiping"
    ],
    "answer": "Tolerance and dialogue"
  },
  {
    "question": "What is meant by the �social environment�?",
    "options": [
      "The weather conditions",
      "The people and relationships that surround us",
      "The buildings and roads",
      "Only political institutions"
    ],
    "answer": "The people and relationships that surround us"
  },
  {
    "question": "Which of these is a right of every Ghanaian citizen?",
    "options": [
      "The right to vote",
      "The right to steal",
      "The right to cheat",
      "The right to disobey laws"
    ],
    "answer": "The right to vote"
  },
  {
    "question": "What is the main function of Parliament in Ghana?",
    "options": [
      "To judge court cases",
      "To conduct exams",
      "To make laws",
      "To enforce traffic rules"
    ],
    "answer": "To make laws"
  },
  {
    "question": "How does culture shape national identity?",
    "options": [
      "By destroying diversity",
      "By promoting uniform behavior",
      "By giving people a sense of belonging and values",
      "By ignoring traditions"
    ],
    "answer": "By giving people a sense of belonging and values"
  },
  {
    "question": "What is one key feature of democracy?",
    "options": [
      "Rule by force",
      "Suppression of dissent",
      "Free and fair elections",
      "One-man rule"
    ],
    "answer": "Free and fair elections"
  },
  {
    "question": "What role does the youth play in national development?",
    "options": [
      "Causing social unrest",
      "Promoting innovation and hard work",
      "Avoiding responsibility",
      "Destroying public property"
    ],
    "answer": "Promoting innovation and hard work"
  },
  {
    "question": "Why is it important to plan families?",
    "options": [
      "To overpopulate communities",
      "To avoid responsibility",
      "To ensure better care and education for children",
      "To increase dependency"
    ],
    "answer": "To ensure better care and education for children"
  },
  {
    "question": "How can an individual help in promoting sustainable development?",
    "options": [
      "Using resources carelessly",
      "Wasting water and electricity",
      "Supporting recycling and conservation",
      "Burning forests"
    ],
    "answer": "Supporting recycling and conservation"
  },
  {
    "question": "Why is adolescent reproductive health education important?",
    "options": [
      "To mislead teenagers",
      "To promote early parenthood",
      "To empower adolescents to make safe choices",
      "To increase risky behavior"
    ],
    "answer": "To empower adolescents to make safe choices"
  },
  {
    "question": "What is one cause of family conflict?",
    "options": [
      "Open communication",
      "Shared responsibilities",
      "Misunderstanding and poor communication",
      "Love and trust"
    ],
    "answer": "Misunderstanding and poor communication"
  },
  {
    "question": "What is the benefit of cultural diversity in a country?",
    "options": [
      "It weakens national unity",
      "It leads to confusion",
      "It enriches national heritage and tolerance",
      "It causes division"
    ],
    "answer": "It enriches national heritage and tolerance"
  },
  {
    "question": "Which of the following describes entrepreneurship?",
    "options": [
      "Depending on others for jobs",
      "Starting and managing one�s own business",
      "Avoiding innovation",
      "Spending without earning"
    ],
    "answer": "Starting and managing one�s own business"
  },
  {
    "question": "How can local resources be used for development?",
    "options": [
      "By exporting all raw materials",
      "By ignoring them",
      "By adding value and using them locally",
      "By hoarding them"
    ],
    "answer": "By adding value and using them locally"
  },
  {
    "question": "Which behavior supports a clean environment?",
    "options": [
      "Dumping waste in gutters",
      "Clearing weeds and planting trees",
      "Spitting in public",
      "Burning plastic"
    ],
    "answer": "Clearing weeds and planting trees"
  },
  {
    "question": "Which of the following is a national duty of every Ghanaian?",
    "options": [
      "Avoiding elections",
      "Paying taxes",
      "Evading civic duties",
      "Littering public places"
    ],
    "answer": "Paying taxes"
  },
  {
    "question": "What is one major impact of climate change on Ghana?",
    "options": [
      "Increased rainfall only",
      "Better farming",
      "Extreme weather and flooding",
      "Decreased temperatures only"
    ],
    "answer": "Extreme weather and flooding"
  },
  {
    "question": "What is a major purpose of marriage in society?",
    "options": [
      "To gain wealth",
      "To fulfill religious obligations only",
      "To establish a family and raise children",
      "To avoid responsibilities"
    ],
    "answer": "To establish a family and raise children"
  },
  {
    "question": "Which of the following is a sign of responsible parenting?",
    "options": [
      "Neglecting children's education",
      "Providing guidance and support",
      "Ignoring children�s needs",
      "Allowing children to make all decisions"
    ],
    "answer": "Providing guidance and support"
  },
  {
    "question": "What role does the Constitution play in Ghana?",
    "options": [
      "Provides traditional songs",
      "Guides national development plans only",
      "Defines laws, rights, and governance systems",
      "Trains athletes"
    ],
    "answer": "Defines laws, rights, and governance systems"
  },
  {
    "question": "How can individuals promote peace in their community?",
    "options": [
      "Gossiping",
      "Spreading false news",
      "Engaging in dialogue and tolerance",
      "Fighting for their beliefs"
    ],
    "answer": "Engaging in dialogue and tolerance"
  },
  {
    "question": "What is one major reason for promoting science and technology in education?",
    "options": [
      "To discourage arts",
      "To help students become independent thinkers and innovators",
      "To increase phone usage",
      "To replace teachers"
    ],
    "answer": "To help students become independent thinkers and innovators"
  },
  {
    "question": "Which institution is responsible for maintaining law and order in Ghana?",
    "options": [
      "The Ministry of Health",
      "The Ghana Education Service",
      "The Ghana Police Service",
      "The Electoral Commission"
    ],
    "answer": "The Ghana Police Service"
  },
  {
    "question": "How does self-identity help a young person?",
    "options": [
      "It causes confusion",
      "It helps them make informed and confident decisions",
      "It reduces responsibility",
      "It isolates them"
    ],
    "answer": "It helps them make informed and confident decisions"
  },
  {
    "question": "Why is it important for individuals to participate in community development?",
    "options": [
      "To become popular",
      "To gain political power",
      "To improve the quality of life for everyone",
      "To control others"
    ],
    "answer": "To improve the quality of life for everyone"
  },
  {
    "question": "Which of these is a danger of population explosion?",
    "options": [
      "Increased family love",
      "Improved healthcare",
      "Overcrowding and pressure on resources",
      "More land for farming"
    ],
    "answer": "Overcrowding and pressure on resources"
  },
  {
    "question": "What is the importance of national symbols?",
    "options": [
      "To promote political parties",
      "To entertain tourists",
      "To unite citizens and reflect national identity",
      "To advertise local businesses"
    ],
    "answer": "To unite citizens and reflect national identity"
  },
  {
    "question": "What is meant by national self-reliance?",
    "options": [
      "Relying only on foreign aid",
      "Depending solely on imports",
      "Building capacity to solve local problems with local resources",
      "Ignoring local industries"
    ],
    "answer": "Building capacity to solve local problems with local resources"
  },
  {
    "question": "Which of the following best describes sustainable development?",
    "options": [
      "Development that meets current needs without compromising the future",
      "Using all resources quickly",
      "Avoiding development to save resources",
      "Building only for future generations"
    ],
    "answer": "Development that meets current needs without compromising the future"
  },
  {
    "question": "What is the role of international organizations like ECOWAS to Ghana?",
    "options": [
      "Discouraging trade",
      "Causing conflict",
      "Promoting regional cooperation and development",
      "Stopping elections"
    ],
    "answer": "Promoting regional cooperation and development"
  },
  {
    "question": "What is one key responsibility of students in school?",
    "options": [
      "Fighting teachers",
      "Destroying school property",
      "Participating in school duties",
      "Avoiding homework"
    ],
    "answer": "Participating in school duties"
  },
  {
    "question": "Which behavior helps protect the physical environment?",
    "options": [
      "Bush burning",
      "Illegal mining",
      "Tree planting",
      "Deforestation"
    ],
    "answer": "Tree planting"
  },
  {
    "question": "What is the main aim of conflict resolution?",
    "options": [
      "To win arguments",
      "To increase tension",
      "To restore peace and understanding",
      "To encourage revenge"
    ],
    "answer": "To restore peace and understanding"
  },
  {
    "question": "Why should we respect cultural practices?",
    "options": [
      "They create confusion",
      "They are outdated",
      "They help preserve heritage and identity",
      "They block development"
    ],
    "answer": "They help preserve heritage and identity"
  },
  {
    "question": "Which of the following promotes discipline in society?",
    "options": [
      "Ignoring the law",
      "Enforcing rules fairly",
      "Rewarding wrongdoers",
      "Promoting favoritism"
    ],
    "answer": "Enforcing rules fairly"
  },
  {
    "question": "What is the purpose of adolescent counseling in schools?",
    "options": [
      "To promote fear",
      "To punish students",
      "To guide students in making responsible decisions",
      "To give strict instructions"
    ],
    "answer": "To guide students in making responsible decisions"
  },
  {
    "question": "How can youth promote development in their communities?",
    "options": [
      "By staying idle",
      "By being violent",
      "By volunteering and initiating projects",
      "By avoiding group work"
    ],
    "answer": "By volunteering and initiating projects"
  },
  {
    "question": "Which of these is a core value in Ghanaian society?",
    "options": [
      "Selfishness",
      "Respect for elders",
      "Dishonesty",
      "Disobedience"
    ],
    "answer": "Respect for elders"
  },
  {
    "question": "What is the relationship between education and social change?",
    "options": [
      "Education causes backwardness",
      "Education promotes innovation and improves society",
      "Education only helps teachers",
      "Education weakens tradition"
    ],
    "answer": "Education promotes innovation and improves society"
  },
  {
    "question": "What is one benefit of understanding your self-identity?",
    "options": [
      "It leads to confusion",
      "It builds confidence and purpose",
      "It causes laziness",
      "It reduces success"
    ],
    "answer": "It builds confidence and purpose"
  },
  {
    "question": "How can responsible citizenship contribute to good governance?",
    "options": [
      "By encouraging bribery",
      "By obeying laws and holding leaders accountable",
      "By ignoring voting",
      "By supporting only friends"
    ],
    "answer": "By obeying laws and holding leaders accountable"
  },
  {
    "question": "Which of these is a positive effect of cultural festivals?",
    "options": [
      "Causing conflicts",
      "Bringing communities together",
      "Promoting violence",
      "Destroying values"
    ],
    "answer": "Bringing communities together"
  },
  {
    "question": "Why is the family called the basic unit of society?",
    "options": [
      "Because it is unimportant",
      "Because it produces future leaders",
      "Because it is a source of conflict",
      "Because it replaces government"
    ],
    "answer": "Because it produces future leaders"
  },
  {
    "question": "What is a sign of national unity?",
    "options": [
      "Tribal conflict",
      "Peaceful coexistence and cooperation",
      "Regional discrimination",
      "Religious division"
    ],
    "answer": "Peaceful coexistence and cooperation"
  },
  {
    "question": "What is the main reason for environmental education in schools?",
    "options": [
      "To scare students",
      "To promote pollution",
      "To raise awareness on conservation and sustainability",
      "To punish littering"
    ],
    "answer": "To raise awareness on conservation and sustainability"
  },
  {
    "question": "What is the impact of corruption on national development?",
    "options": [
      "Improves trust in government",
      "Encourages growth",
      "Reduces trust and wastes resources",
      "Promotes justice"
    ],
    "answer": "Reduces trust and wastes resources"
  },
  {
    "question": "What is the essence of human rights in a democracy?",
    "options": [
      "To create conflict",
      "To promote inequality",
      "To protect freedoms and dignity of citizens",
      "To weaken the constitution"
    ],
    "answer": "To protect freedoms and dignity of citizens"
  },
  {
    "question": "Why is voting important in a democracy?",
    "options": [
      "It wastes time",
      "It helps citizens choose their leaders",
      "It encourages violence",
      "It is only for the rich"
    ],
    "answer": "It helps citizens choose their leaders"
  },
  {
    "question": "Which of these best promotes responsible parenting?",
    "options": [
      "Spending little time with children",
      "Providing emotional and financial support",
      "Ignoring school activities",
      "Allowing children to skip rules"
    ],
    "answer": "Providing emotional and financial support"
  },
  {
    "question": "What is the impact of illegal mining on Ghana�s environment?",
    "options": [
      "It purifies rivers",
      "It boosts tourism",
      "It causes land degradation and water pollution",
      "It creates forests"
    ],
    "answer": "It causes land degradation and water pollution"
  },
  {
    "question": "How does socialization influence behavior?",
    "options": [
      "It discourages learning",
      "It isolates people",
      "It shapes values, beliefs, and norms",
      "It prevents friendships"
    ],
    "answer": "It shapes values, beliefs, and norms"
  },
  {
    "question": "Why should citizens know their rights?",
    "options": [
      "To cause rebellion",
      "To fight others",
      "To protect themselves and seek justice",
      "To disrespect leaders"
    ],
    "answer": "To protect themselves and seek justice"
  },
  {
    "question": "What is one benefit of national symbols like the national anthem?",
    "options": [
      "To confuse foreigners",
      "To celebrate foreign leaders",
      "To promote national pride and unity",
      "To divide the people"
    ],
    "answer": "To promote national pride and unity"
  },
  {
    "question": "How does education reduce poverty?",
    "options": [
      "By teaching people to beg",
      "By making people dependent",
      "By equipping individuals with skills for employment",
      "By avoiding hard work"
    ],
    "answer": "By equipping individuals with skills for employment"
  },
  {
    "question": "What is one consequence of overpopulation?",
    "options": [
      "Increased job opportunities",
      "Better housing",
      "Overstretched social services",
      "More farmland"
    ],
    "answer": "Overstretched social services"
  },
  {
    "question": "How can a country promote self-reliance?",
    "options": [
      "Importing everything",
      "Discouraging local businesses",
      "Investing in local industries and skills",
      "Copying other nations blindly"
    ],
    "answer": "Investing in local industries and skills"
  },
  {
    "question": "What is the responsibility of a leader in governance?",
    "options": [
      "To serve the interest of only their family",
      "To uphold the law and promote national welfare",
      "To enrich themselves",
      "To ignore public opinion"
    ],
    "answer": "To uphold the law and promote national welfare"
  },
  {
    "question": "Which of these is a sign of a peaceful society?",
    "options": [
      "Frequent strikes and violence",
      "Religious intolerance",
      "Cooperation and respect among citizens",
      "Abuse of rights"
    ],
    "answer": "Cooperation and respect among citizens"
  },
  {
    "question": "What is the role of the youth in population control?",
    "options": [
      "Avoiding education",
      "Engaging in early parenthood",
      "Practicing responsible behavior",
      "Ignoring health advice"
    ],
    "answer": "Practicing responsible behavior"
  },
  {
    "question": "What is one benefit of national unity?",
    "options": [
      "War and instability",
      "Divided leadership",
      "Shared development goals",
      "Tribal favoritism"
    ],
    "answer": "Shared development goals"
  },
  {
    "question": "What is a key element of Ghana�s constitution?",
    "options": [
      "Promotion of dictatorship",
      "Restriction of freedoms",
      "Protection of rights and rule of law",
      "Suppression of voters"
    ],
    "answer": "Protection of rights and rule of law"
  },
  {
    "question": "Which of the following is a form of social responsibility?",
    "options": [
      "Cheating in exams",
      "Obeying traffic rules",
      "Disrespecting the elderly",
      "Dodging national service"
    ],
    "answer": "Obeying traffic rules"
  },
  {
    "question": "How can responsible followership improve leadership?",
    "options": [
      "By blindly supporting everything",
      "By holding leaders accountable and being active citizens",
      "By ignoring national issues",
      "By promoting bribery"
    ],
    "answer": "By holding leaders accountable and being active citizens"
  },
  {
    "question": "Which behavior shows patriotism?",
    "options": [
      "Littering in public places",
      "Obeying laws and protecting public property",
      "Destroying national symbols",
      "Ignoring elections"
    ],
    "answer": "Obeying laws and protecting public property"
  },
  {
    "question": "What is the meaning of the term �entrepreneur�?",
    "options": [
      "Someone who copies ideas",
      "Someone who inherits wealth",
      "Someone who starts and manages a business",
      "Someone who avoids risk"
    ],
    "answer": "Someone who starts and manages a business"
  },
  {
    "question": "What does cultural tolerance promote?",
    "options": [
      "Discrimination",
      "Religious conflict",
      "Peaceful coexistence",
      "Hatred"
    ],
    "answer": "Peaceful coexistence"
  },
  {
    "question": "How can science improve agriculture in Ghana?",
    "options": [
      "By increasing manual labor",
      "By using outdated tools",
      "By introducing improved farming methods and technology",
      "By reducing farm size"
    ],
    "answer": "By introducing improved farming methods and technology"
  },
  {
    "question": "What is the major role of traditional leaders in Ghana?",
    "options": [
      "Fighting government policies",
      "Dividing communities",
      "Promoting culture and resolving disputes",
      "Avoiding community responsibilities"
    ],
    "answer": "Promoting culture and resolving disputes"
  },
  {
    "question": "What is the purpose of national development plans?",
    "options": [
      "To delay progress",
      "To confuse citizens",
      "To guide economic and social transformation",
      "To benefit only politicians"
    ],
    "answer": "To guide economic and social transformation"
  },
  {
    "question": "Which of these best explains environmental degradation?",
    "options": [
      "Improvement of land for farming",
      "Proper waste disposal",
      "Damage to the environment through human activity",
      "Tree planting"
    ],
    "answer": "Damage to the environment through human activity"
  },
  {
    "question": "How can the youth contribute to reducing unemployment?",
    "options": [
      "Depending on government jobs only",
      "Learning no skills",
      "Engaging in entrepreneurship and innovation",
      "Avoiding technology"
    ],
    "answer": "Engaging in entrepreneurship and innovation"
  },
  {
    "question": "Which institution ensures the protection of rights in Ghana?",
    "options": [
      "Football Association",
      "Electoral Commission",
      "Commission on Human Rights and Administrative Justice (CHRAJ)",
      "Ministry of Agriculture"
    ],
    "answer": "Commission on Human Rights and Administrative Justice (CHRAJ)"
  },
  {
    "question": "What does population density refer to?",
    "options": [
      "Number of children in a family",
      "Number of people in a region per square kilometer",
      "Total number of animals in a place",
      "Amount of rainfall in a year"
    ],
    "answer": "Number of people in a region per square kilometer"
  },
  {
    "question": "Which of these is an example of cultural expression?",
    "options": [
      "Music and dance",
      "Banking and insurance",
      "Mathematics",
      "Laboratory tests"
    ],
    "answer": "Music and dance"
  },
  {
    "question": "What is the importance of obeying national laws?",
    "options": [
      "It causes fear",
      "It promotes order and peaceful coexistence",
      "It delays progress",
      "It limits freedom unfairly"
    ],
    "answer": "It promotes order and peaceful coexistence"
  },
  {
    "question": "Why is the family considered a key agent of socialization?",
    "options": [
      "It gives birth to criminals",
      "It helps individuals learn societal values and behavior",
      "It promotes laziness",
      "It destroys traditions"
    ],
    "answer": "It helps individuals learn societal values and behavior"
  },
  {
    "question": "What is one danger of ignoring reproductive health education?",
    "options": [
      "Improved academic performance",
      "Increased self-awareness",
      "Risk of teenage pregnancy and STIs",
      "Better sports performance"
    ],
    "answer": "Risk of teenage pregnancy and STIs"
  },
  {
    "question": "What does it mean to be self-reliant as a student?",
    "options": [
      "Copying in exams",
      "Depending on friends for help",
      "Taking initiative and solving problems independently",
      "Avoiding personal growth"
    ],
    "answer": "Taking initiative and solving problems independently"
  },
  {
    "question": "What is the impact of brain drain on national development?",
    "options": [
      "Increased skilled workforce",
      "Better local services",
      "Loss of skilled labor to other countries",
      "Lower cost of education"
    ],
    "answer": "Loss of skilled labor to other countries"
  },
  {
    "question": "What is one reason for conflict in communities?",
    "options": [
      "Respecting laws",
      "Open communication",
      "Misunderstanding and lack of tolerance",
      "Volunteering"
    ],
    "answer": "Misunderstanding and lack of tolerance"
  },
  {
    "question": "Which of these promotes gender equality?",
    "options": [
      "Denying girls education",
      "Allowing only men to vote",
      "Giving equal opportunities to all genders",
      "Paying women less than men"
    ],
    "answer": "Giving equal opportunities to all genders"
  },
  {
    "question": "What does the phrase 'world of work' refer to?",
    "options": [
      "Only academic studies",
      "Sports and games",
      "All career fields and employment sectors",
      "Religious groups only"
    ],
    "answer": "All career fields and employment sectors"
  },
  {
    "question": "How can Ghana benefit from the international community?",
    "options": [
      "Through illegal trade",
      "By isolating from others",
      "Through cooperation and diplomacy",
      "By refusing foreign investment"
    ],
    "answer": "Through cooperation and diplomacy"
  },
  {
    "question": "What is the function of responsible followership in democracy?",
    "options": [
      "Supporting bad leadership",
      "Ensuring accountability and civic participation",
      "Avoiding elections",
      "Ignoring issues"
    ],
    "answer": "Ensuring accountability and civic participation"
  },
  {
    "question": "Why should marriage be considered a serious commitment?",
    "options": [
      "Because it�s fashionable",
      "Because it guarantees wealth",
      "Because it involves responsibilities and legal obligations",
      "Because it makes one popular"
    ],
    "answer": "Because it involves responsibilities and legal obligations"
  },
  {
    "question": "What is the impact of improper waste disposal?",
    "options": [
      "Clean surroundings",
      "Pollution and disease outbreaks",
      "Improved air quality",
      "Increased tourism"
    ],
    "answer": "Pollution and disease outbreaks"
  },
  {
    "question": "How can students contribute to a clean school environment?",
    "options": [
      "Burning rubbish everywhere",
      "Refusing to clean",
      "Using dustbins and avoiding littering",
      "Damaging toilets"
    ],
    "answer": "Using dustbins and avoiding littering"
  },
  {
    "question": "What is the best way to resolve a family conflict?",
    "options": [
      "Fighting openly",
      "Keeping grudges",
      "Peaceful dialogue and understanding",
      "Avoiding communication"
    ],
    "answer": "Peaceful dialogue and understanding"
  },
  {
    "question": "Why should we protect Ghana�s natural resources?",
    "options": [
      "To sell them quickly",
      "To allow foreigners to exploit them",
      "To ensure sustainability for future generations",
      "To reduce land area"
    ],
    "answer": "To ensure sustainability for future generations"
  },
  {
    "question": "What is the importance of being tolerant in a multicultural society?",
    "options": [
      "It encourages conflict",
      "It reduces cooperation",
      "It fosters peace and unity",
      "It promotes discrimination"
    ],
    "answer": "It fosters peace and unity"
  },
  {
    "question": "How can education lead to societal change?",
    "options": [
      "By spreading ignorance",
      "By making people passive",
      "By developing informed and skilled citizens",
      "By encouraging laziness"
    ],
    "answer": "By developing informed and skilled citizens"
  },
  {
    "question": "What is responsible parenting?",
    "options": [
      "Abandoning children",
      "Providing basic needs and moral guidance",
      "Allowing total freedom",
      "Avoiding communication with children"
    ],
    "answer": "Providing basic needs and moral guidance"
  },
  {
    "question": "Which of these helps reduce conflicts during elections?",
    "options": [
      "Spreading false information",
      "Rigging results",
      "Using violence",
      "Transparency and peaceful conduct"
    ],
    "answer": "Transparency and peaceful conduct"
  },
  {
    "question": "What role does the individual play in community development?",
    "options": [
      "Avoiding taxes",
      "Participating in clean-up exercises",
      "Encouraging violence",
      "Destroying public property"
    ],
    "answer": "Participating in clean-up exercises"
  },
  {
    "question": "What is the purpose of sustainable development?",
    "options": [
      "Development that ignores the future",
      "Short-term gain only",
      "Development that meets present needs without compromising the future",
      "Development for only the rich"
    ],
    "answer": "Development that meets present needs without compromising the future"
  },
  {
    "question": "Which activity supports environmental protection?",
    "options": [
      "Tree planting",
      "Illegal mining",
      "Burning plastic waste",
      "Deforestation"
    ],
    "answer": "Tree planting"
  },
  {
    "question": "What is one duty of a citizen in a democracy?",
    "options": [
      "Avoiding elections",
      "Disobeying laws",
      "Participation in decision-making processes",
      "Ignoring national issues"
    ],
    "answer": "Participation in decision-making processes"
  },
  {
    "question": "What is adolescence?",
    "options": [
      "The stage before birth",
      "Old age",
      "A period of transition from childhood to adulthood",
      "Middle age"
    ],
    "answer": "A period of transition from childhood to adulthood"
  },
  {
    "question": "How can corruption affect national development?",
    "options": [
      "By increasing investor confidence",
      "By encouraging accountability",
      "By misusing public funds",
      "By improving infrastructure"
    ],
    "answer": "By misusing public funds"
  },
  {
    "question": "Which value promotes peace in a community?",
    "options": [
      "Selfishness",
      "Tolerance",
      "Dishonesty",
      "Intolerance"
    ],
    "answer": "Tolerance"
  },
  {
    "question": "What is the importance of national symbols?",
    "options": [
      "They create division",
      "They promote identity and unity",
      "They are only for tourists",
      "They are meaningless"
    ],
    "answer": "They promote identity and unity"
  },
  {
    "question": "What is cultural diversity?",
    "options": [
      "One group dominating others",
      "The variety of cultural expressions within a society",
      "Abandoning traditions",
      "Refusing to accept other cultures"
    ],
    "answer": "The variety of cultural expressions within a society"
  },
  {
    "question": "Which of these is a good practice for environmental sanitation?",
    "options": [
      "Open defecation",
      "Littering streets",
      "Dumping refuse in rivers",
      "Cleaning gutters regularly"
    ],
    "answer": "Cleaning gutters regularly"
  },
  {
    "question": "What does the term 'nation building' refer to?",
    "options": [
      "Construction of tall buildings",
      "Military recruitment",
      "Efforts to develop and unify a country",
      "Sending people abroad"
    ],
    "answer": "Efforts to develop and unify a country"
  },
  {
    "question": "What is peer pressure?",
    "options": [
      "Positive encouragement from parents",
      "Influence from people of the same age group",
      "Guidance from teachers",
      "Support from leaders"
    ],
    "answer": "Influence from people of the same age group"
  },
  {
    "question": "What is the main source of Ghana�s constitution?",
    "options": [
      "The Bible",
      "The Qur'an",
      "The 1992 Constitution",
      "TV programs"
    ],
    "answer": "The 1992 Constitution"
  },
  {
    "question": "How can technology help solve unemployment?",
    "options": [
      "By reducing the need for education",
      "By encouraging laziness",
      "By creating new job opportunities through innovation",
      "By promoting violence"
    ],
    "answer": "By creating new job opportunities through innovation"
  },
  {
    "question": "Which of these is a responsible way to use social media?",
    "options": [
      "Spreading fake news",
      "Cyberbullying",
      "Educating and informing others",
      "Posting harmful content"
    ],
    "answer": "Educating and informing others"
  },
  {
    "question": "What is the effect of child labor on education?",
    "options": [
      "Improves learning",
      "Provides more school books",
      "Prevents regular attendance and learning",
      "Encourages teamwork"
    ],
    "answer": "Prevents regular attendance and learning"
  },
  {
    "question": "What is meant by social responsibility?",
    "options": [
      "Being lazy in society",
      "Only caring for oneself",
      "Caring for and contributing to the welfare of the community",
      "Avoiding rules"
    ],
    "answer": "Caring for and contributing to the welfare of the community"
  },
  {
    "question": "Which of these is an effect of environmental pollution?",
    "options": [
      "Increased crop yields",
      "Clean air",
      "Health problems and poor sanitation",
      "Improved tourism"
    ],
    "answer": "Health problems and poor sanitation"
  },
  {
    "question": "What is one goal of conflict resolution?",
    "options": [
      "Creating more enemies",
      "Starting fights",
      "Restoring peace and understanding",
      "Avoiding justice"
    ],
    "answer": "Restoring peace and understanding"
  },
  {
    "question": "Why should we respect elders in our communities?",
    "options": [
      "They always give gifts",
      "They are rich",
      "They possess wisdom and experience",
      "They are friends with celebrities"
    ],
    "answer": "They possess wisdom and experience"
  },
  {
    "question": "What is family planning?",
    "options": [
      "Building more houses",
      "Having as many children as possible",
      "Deciding when and how many children to have",
      "Avoiding marriage"
    ],
    "answer": "Deciding when and how many children to have"
  },
  {
    "question": "How does the constitution protect individuals?",
    "options": [
      "By banning education",
      "By allowing only the rich to vote",
      "By defining rights and limiting power",
      "By supporting violence"
    ],
    "answer": "By defining rights and limiting power"
  },
  {
    "question": "Why should students care about national issues?",
    "options": [
      "They are too young to understand",
      "They can't vote yet",
      "They are future leaders and citizens",
      "It�s only for politicians"
    ],
    "answer": "They are future leaders and citizens"
  },
  {
    "question": "What is one benefit of cultural festivals?",
    "options": [
      "Increasing conflict",
      "Promoting cultural heritage and unity",
      "Encouraging laziness",
      "Wasting money"
    ],
    "answer": "Promoting cultural heritage and unity"
  },
  {
    "question": "What is the meaning of governance?",
    "options": [
      "Only voting",
      "Disrespecting leaders",
      "Management of public affairs and decision-making",
      "Avoiding development"
    ],
    "answer": "Management of public affairs and decision-making"
  },
  {
    "question": "Which behavior shows good citizenship?",
    "options": [
      "Destroying national property",
      "Dodging taxes",
      "Respecting laws and paying taxes",
      "Cheating in school"
    ],
    "answer": "Respecting laws and paying taxes"
  },
  {
    "question": "What does self-identity involve?",
    "options": [
      "Copying others� lives",
      "Knowing your unique qualities and beliefs",
      "Wearing expensive clothes",
      "Acting like celebrities"
    ],
    "answer": "Knowing your unique qualities and beliefs"
  },
  {
    "question": "Why should students be concerned about population growth?",
    "options": [
      "It helps everyone become famous",
      "It affects resources and future planning",
      "It means more friends",
      "It makes learning easier"
    ],
    "answer": "It affects resources and future planning"
  },
  {
    "question": "Which of these is a benefit of tourism to Ghana?",
    "options": [
      "Littering sites",
      "Promoting cultural exchange and earning foreign income",
      "Closing cultural sites",
      "Causing traffic"
    ],
    "answer": "Promoting cultural exchange and earning foreign income"
  },
  {
    "question": "What is meant by national integration?",
    "options": [
      "Separating people by tribe",
      "Bringing people together to form one united nation",
      "Creating borders within a country",
      "Excluding minorities"
    ],
    "answer": "Bringing people together to form one united nation"
  },
  {
    "question": "What is peer education?",
    "options": [
      "Learning from TV only",
      "Education through people of the same age group",
      "Parents teaching teachers",
      "Children educating adults only"
    ],
    "answer": "Education through people of the same age group"
  },
  {
    "question": "What is the effect of broken homes on children?",
    "options": [
      "Better mental health",
      "Greater concentration",
      "Emotional and behavioral challenges",
      "Improved leadership"
    ],
    "answer": "Emotional and behavioral challenges"
  },
  {
    "question": "Which of these is a moral value?",
    "options": [
      "Dishonesty",
      "Corruption",
      "Kindness",
      "Cheating"
    ],
    "answer": "Kindness"
  },
  {
    "question": "How can young people participate in governance?",
    "options": [
      "By ignoring national issues",
      "Through civic education, voting, and volunteering",
      "By avoiding school",
      "By protesting violently"
    ],
    "answer": "Through civic education, voting, and volunteering"
  },
  {
    "question": "What is a constitution?",
    "options": [
      "A set of fashion rules",
      "A cooking guide",
      "A legal document outlining the rules of a country",
      "A movie script"
    ],
    "answer": "A legal document outlining the rules of a country"
  },
  {
    "question": "What can help reduce poverty in Ghana?",
    "options": [
      "Avoiding work",
      "Promoting skill training and job creation",
      "Discouraging education",
      "Wasting resources"
    ],
    "answer": "Promoting skill training and job creation"
  },
  {
    "question": "How can people show respect for public property?",
    "options": [
      "Damaging school desks",
      "Littering parks",
      "Using facilities carefully and responsibly",
      "Stealing road signs"
    ],
    "answer": "Using facilities carefully and responsibly"
  },
  {
    "question": "Which of the following is a major economic activity in Ghana?",
    "options": [
      "Snow farming",
      "Oil drilling in deserts",
      "Farming and fishing",
      "Ice sculpture"
    ],
    "answer": "Farming and fishing"
  },
  {
    "question": "What is one role of education in national development?",
    "options": [
      "Creating illiteracy",
      "Training skilled manpower",
      "Discouraging hard work",
      "Spreading superstition"
    ],
    "answer": "Training skilled manpower"
  },
  {
    "question": "Why is regular sanitation important in our communities?",
    "options": [
      "To spread diseases",
      "To beautify only schools",
      "To promote good health",
      "To support pollution"
    ],
    "answer": "To promote good health"
  },
  {
    "question": "What is a key function of marriage in society?",
    "options": [
      "Encouraging disunity",
      "Promoting family and societal stability",
      "Reducing population",
      "Avoiding cultural values"
    ],
    "answer": "Promoting family and societal stability"
  },
  {
    "question": "Which of these helps achieve sustainable development?",
    "options": [
      "Overexploiting resources",
      "Ignoring environmental laws",
      "Replanting trees after deforestation",
      "Polluting rivers"
    ],
    "answer": "Replanting trees after deforestation"
  },
  {
    "question": "What is an example of a national symbol in Ghana?",
    "options": [
      "The Eiffel Tower",
      "The Black Star",
      "The Statue of Liberty",
      "The Great Wall"
    ],
    "answer": "The Black Star"
  },
  {
    "question": "Which of the following is an environmental challenge in Ghana?",
    "options": [
      "Flooding",
      "Peacekeeping",
      "Banking",
      "Tourism"
    ],
    "answer": "Flooding"
  },
  {
    "question": "What is the main purpose of the constitution?",
    "options": [
      "To control only rich people",
      "To guide governance and protect rights",
      "To limit education",
      "To support dictatorship"
    ],
    "answer": "To guide governance and protect rights"
  },
  {
    "question": "Which of the following promotes national unity?",
    "options": [
      "Tribalism",
      "Discrimination",
      "Equal rights for all citizens",
      "Exclusion of minorities"
    ],
    "answer": "Equal rights for all citizens"
  },
  {
    "question": "Why is peace important for development?",
    "options": [
      "It encourages war",
      "It slows down business",
      "It creates a stable environment for growth",
      "It destroys infrastructure"
    ],
    "answer": "It creates a stable environment for growth"
  },
  {
    "question": "What is an economic benefit of proper resource utilization?",
    "options": [
      "Resource scarcity",
      "Increased national income",
      "Unemployment",
      "Pollution"
    ],
    "answer": "Increased national income"
  },
  {
    "question": "How can young people contribute to national development?",
    "options": [
      "Avoiding civic duties",
      "Being apathetic",
      "Developing skills and innovating",
      "Spreading violence"
    ],
    "answer": "Developing skills and innovating"
  },
  {
    "question": "Why should laws be obeyed?",
    "options": [
      "To encourage anarchy",
      "To create confusion",
      "To maintain peace and order",
      "To support criminal activity"
    ],
    "answer": "To maintain peace and order"
  },
  {
    "question": "Which of these promotes responsible citizenship?",
    "options": [
      "Avoiding elections",
      "Paying taxes and obeying laws",
      "Breaking traffic rules",
      "Spreading rumors"
    ],
    "answer": "Paying taxes and obeying laws"
  },
  {
    "question": "What does tolerance in democracy mean?",
    "options": [
      "Fighting opponents",
      "Respecting different opinions",
      "Suppressing views",
      "Limiting speech"
    ],
    "answer": "Respecting different opinions"
  },
  {
    "question": "What is one function of traditional leadership in Ghana?",
    "options": [
      "Judging national elections",
      "Providing spiritual guidance and settling disputes",
      "Controlling national police",
      "Leading the parliament"
    ],
    "answer": "Providing spiritual guidance and settling disputes"
  },
  {
    "question": "How does corruption harm the economy?",
    "options": [
      "It attracts investors",
      "It increases trust",
      "It misuses public funds and discourages investment",
      "It builds infrastructure"
    ],
    "answer": "It misuses public funds and discourages investment"
  },
  {
    "question": "What is one benefit of science and technology?",
    "options": [
      "Limiting innovation",
      "Improving productivity and quality of life",
      "Creating ignorance",
      "Avoiding education"
    ],
    "answer": "Improving productivity and quality of life"
  },
  {
    "question": "Why are population statistics important for a country?",
    "options": [
      "For guessing food supply",
      "For national planning and development",
      "For confusing citizens",
      "For entertainment"
    ],
    "answer": "For national planning and development"
  },
  {
    "question": "What is one effect of illegal mining in Ghana?",
    "options": [
      "Improved health",
      "Increased soil fertility",
      "Environmental degradation",
      "Growth of forest cover"
    ],
    "answer": "Environmental degradation"
  },
  {
    "question": "Which of these best describes entrepreneurship?",
    "options": [
      "Looking for white-collar jobs",
      "Starting and managing a business",
      "Avoiding economic activity",
      "Waiting for government employment"
    ],
    "answer": "Starting and managing a business"
  },
  {
    "question": "What does national sovereignty mean?",
    "options": [
      "Being ruled by another country",
      "Complete independence and control over national affairs",
      "Dependence on foreign aid",
      "Having no constitution"
    ],
    "answer": "Complete independence and control over national affairs"
  },
  {
    "question": "What is one reason for teaching adolescent reproductive health?",
    "options": [
      "To promote early pregnancy",
      "To discourage learning",
      "To help young people make safe and informed choices",
      "To promote peer pressure"
    ],
    "answer": "To help young people make safe and informed choices"
  },
  {
    "question": "Which activity shows environmental irresponsibility?",
    "options": [
      "Proper waste disposal",
      "Tree planting",
      "Galamsey operations",
      "Using biodegradable products"
    ],
    "answer": "Galamsey operations"
  },
  {
    "question": "What is one responsibility of parents?",
    "options": [
      "Ignoring children",
      "Providing for the family and teaching values",
      "Avoiding discipline",
      "Abandoning roles"
    ],
    "answer": "Providing for the family and teaching values"
  },
  {
    "question": "Why should children respect their elders?",
    "options": [
      "Because it is a law",
      "To learn and maintain societal values",
      "To get gifts",
      "To avoid work"
    ],
    "answer": "To learn and maintain societal values"
  },
  {
    "question": "What is meant by civic responsibility?",
    "options": [
      "Only attending school",
      "Engaging in activities that benefit society",
      "Avoiding the community",
      "Joining only sports"
    ],
    "answer": "Engaging in activities that benefit society"
  },
  {
    "question": "Which action can improve sanitation?",
    "options": [
      "Littering public spaces",
      "Burning plastic",
      "Dumping refuse into rivers",
      "Participating in clean-up campaigns"
    ],
    "answer": "Participating in clean-up campaigns"
  },
  {
    "question": "What is a key goal of democracy?",
    "options": [
      "Power without accountability",
      "Silencing opposition",
      "Inclusive participation and protection of rights",
      "Favoritism"
    ],
    "answer": "Inclusive participation and protection of rights"
  },
  {
    "question": "Which of the following is a form of informal education?",
    "options": [
      "University lecture",
      "TV program teaching hygiene",
      "WAEC exams",
      "Library textbooks"
    ],
    "answer": "TV program teaching hygiene"
  },
  {
    "question": "What can cause family instability?",
    "options": [
      "Communication and love",
      "Lack of trust and responsibility",
      "Planning and support",
      "Education and respect"
    ],
    "answer": "Lack of trust and responsibility"
  },
  {
    "question": "Which sector uses natural resources for development?",
    "options": [
      "Mining and agriculture",
      "Banking only",
      "Education alone",
      "Tourism only"
    ],
    "answer": "Mining and agriculture"
  },
  {
    "question": "What does it mean to be self-reliant?",
    "options": [
      "Depending on others",
      "Relying on foreign aid",
      "Being able to provide for one�s own needs",
      "Always borrowing"
    ],
    "answer": "Being able to provide for one�s own needs"
  },
  {
    "question": "How can students promote peace?",
    "options": [
      "Fighting with friends",
      "Resolving conflicts peacefully",
      "Spreading hate speech",
      "Supporting violence"
    ],
    "answer": "Resolving conflicts peacefully"
  },
  {
    "question": "What is a negative effect of unemployment?",
    "options": [
      "Increased savings",
      "Improved standard of living",
      "Increased crime and poverty",
      "Higher productivity"
    ],
    "answer": "Increased crime and poverty"
  },
  {
    "question": "What is national development?",
    "options": [
      "Importing everything",
      "Excluding people from decisions",
      "Improving the quality of life in a nation",
      "Destroying cultural values"
    ],
    "answer": "Improving the quality of life in a nation"
  },
  {
    "question": "What is a key element of national identity?",
    "options": [
      "Dividing people by religion",
      "Common values and shared symbols",
      "Ignoring cultural norms",
      "Copying foreign traditions"
    ],
    "answer": "Common values and shared symbols"
  },
  {
    "question": "Which of these promotes responsible adolescence?",
    "options": [
      "Drug abuse",
      "Positive peer influence",
      "Skipping school",
      "Engaging in fights"
    ],
    "answer": "Positive peer influence"
  },
  {
    "question": "How does education reduce poverty?",
    "options": [
      "By delaying employment",
      "By discouraging savings",
      "By equipping individuals with skills for better jobs",
      "By increasing dependency"
    ],
    "answer": "By equipping individuals with skills for better jobs"
  },
  {
    "question": "Why is it important to respect the constitution?",
    "options": [
      "To ignore leaders",
      "To break laws",
      "To ensure order and justice",
      "To stop voting"
    ],
    "answer": "To ensure order and justice"
  },
  {
    "question": "What is the main role of the Electoral Commission?",
    "options": [
      "Training teachers",
      "Organizing fair and credible elections",
      "Making laws",
      "Leading protests"
    ],
    "answer": "Organizing fair and credible elections"
  },
  {
    "question": "What is one benefit of cultural education?",
    "options": [
      "Creating division",
      "Building national unity and identity",
      "Causing confusion",
      "Rejecting traditions"
    ],
    "answer": "Building national unity and identity"
  },
  {
    "question": "Which of these is a national value?",
    "options": [
      "Cheating",
      "Corruption",
      "Honesty",
      "Disobedience"
    ],
    "answer": "Honesty"
  },
  {
    "question": "What is one effect of teenage pregnancy?",
    "options": [
      "Improved education",
      "Increased dropout rates",
      "Better job opportunities",
      "Higher income"
    ],
    "answer": "Increased dropout rates"
  },
  {
    "question": "What does the rule of law mean?",
    "options": [
      "Only the rich follow the law",
      "Everyone is subject to the law",
      "Leaders are above the law",
      "Laws apply only in cities"
    ],
    "answer": "Everyone is subject to the law"
  },
  {
    "question": "Which factor enhances national development?",
    "options": [
      "Disunity",
      "Corruption",
      "Hard work and innovation",
      "Tribal conflict"
    ],
    "answer": "Hard work and innovation"
  },
  {
    "question": "What is the importance of national symbols?",
    "options": [
      "To confuse citizens",
      "To represent the identity and values of a country",
      "To promote division",
      "To celebrate other countries"
    ],
    "answer": "To represent the identity and values of a country"
  },
  {
    "question": "How can the youth help reduce unemployment?",
    "options": [
      "Relying solely on government jobs",
      "Avoiding skill acquisition",
      "Engaging in entrepreneurship",
      "Waiting for foreign aid"
    ],
    "answer": "Engaging in entrepreneurship"
  },
  {
    "question": "What does 'our physical environment' include?",
    "options": [
      "Only schools and hospitals",
      "Natural and man-made surroundings",
      "Only government offices",
      "Books and pens"
    ],
    "answer": "Natural and man-made surroundings"
  },
  {
    "question": "What is one effect of poor sanitation?",
    "options": [
      "Clean cities",
      "Improved tourism",
      "Outbreak of diseases",
      "Higher productivity"
    ],
    "answer": "Outbreak of diseases"
  },
  {
    "question": "Why should citizens participate in elections?",
    "options": [
      "To cause confusion",
      "To enjoy holidays",
      "To influence national leadership",
      "To avoid taxes"
    ],
    "answer": "To influence national leadership"
  },
  {
    "question": "How can Ghanaians protect water bodies?",
    "options": [
      "Washing cars in rivers",
      "Dumping waste into them",
      "Avoiding illegal mining",
      "Bathing animals in lakes"
    ],
    "answer": "Avoiding illegal mining"
  },
  {
    "question": "What role does culture play in national identity?",
    "options": [
      "Divides society",
      "Builds pride and belonging",
      "Makes people forget tradition",
      "Encourages discrimination"
    ],
    "answer": "Builds pride and belonging"
  },
  {
    "question": "Why is it important to protect the environment?",
    "options": [
      "To reduce food",
      "To cause flooding",
      "To preserve it for future generations",
      "To destroy forests"
    ],
    "answer": "To preserve it for future generations"
  },
  {
    "question": "Which of these is a civic responsibility?",
    "options": [
      "Evading taxes",
      "Voting during elections",
      "Refusing education",
      "Breaking laws"
    ],
    "answer": "Voting during elections"
  },
  {
    "question": "What is the meaning of national unity?",
    "options": [
      "Fighting among tribes",
      "Working together as one people",
      "Disagreeing with every policy",
      "Ignoring national laws"
    ],
    "answer": "Working together as one people"
  },
  {
    "question": "How can education promote societal change?",
    "options": [
      "By spreading ignorance",
      "By equipping citizens with knowledge and skills",
      "By encouraging crime",
      "By limiting ideas"
    ],
    "answer": "By equipping citizens with knowledge and skills"
  },
  {
    "question": "Which of these supports family stability?",
    "options": [
      "Neglect and abuse",
      "Strong communication and love",
      "Abandonment of roles",
      "Dishonesty"
    ],
    "answer": "Strong communication and love"
  },
  {
    "question": "Why is self-identity important?",
    "options": [
      "To copy others",
      "To understand and appreciate oneself",
      "To feel confused",
      "To rely on others for decisions"
    ],
    "answer": "To understand and appreciate oneself"
  },
  {
    "question": "What is the role of the youth in community development?",
    "options": [
      "Destroying properties",
      "Participating in clean-ups and volunteering",
      "Avoiding social programs",
      "Spreading rumors"
    ],
    "answer": "Participating in clean-ups and volunteering"
  },
  {
    "question": "How can responsible parenting help national development?",
    "options": [
      "By raising irresponsible citizens",
      "By ignoring children�s needs",
      "By nurturing disciplined and productive citizens",
      "By avoiding education"
    ],
    "answer": "By nurturing disciplined and productive citizens"
  },
  {
    "question": "Which of these is a global environmental issue?",
    "options": [
      "Illegal street vending",
      "Littering only schools",
      "Climate change",
      "Noisy classrooms"
    ],
    "answer": "Climate change"
  },
  {
    "question": "How can individuals support socio-economic development?",
    "options": [
      "Avoiding taxes",
      "Destroying infrastructure",
      "Starting businesses and creating jobs",
      "Spreading conflict"
    ],
    "answer": "Starting businesses and creating jobs"
  },
  {
    "question": "Why is it important to preserve cultural heritage?",
    "options": [
      "To lose identity",
      "To ignore traditions",
      "To understand our history and values",
      "To copy other cultures"
    ],
    "answer": "To understand our history and values"
  },
  {
    "question": "What does the term �followership� imply?",
    "options": [
      "Opposing every leader",
      "Blindly obeying laws",
      "Supporting leaders with responsibility",
      "Breaking laws"
    ],
    "answer": "Supporting leaders with responsibility"
  },
  {
    "question": "Which sector benefits most from science and technology?",
    "options": [
      "Only music",
      "All sectors including health, education, and agriculture",
      "Only sports",
      "Only religion"
    ],
    "answer": "All sectors including health, education, and agriculture"
  },
  {
    "question": "Which of these is a component of adolescent reproductive health?",
    "options": [
      "Superstitions",
      "Healthy relationships and body changes",
      "Street fights",
      "Noise-making"
    ],
    "answer": "Healthy relationships and body changes"
  },
  {
    "question": "How does Ghana benefit from the international community?",
    "options": [
      "By staying isolated",
      "Through trade, aid, and diplomacy",
      "By ignoring global events",
      "By refusing foreign help"
    ],
    "answer": "Through trade, aid, and diplomacy"
  },
  {
    "question": "What is one aim of sustainable development?",
    "options": [
      "Using all resources quickly",
      "Preserving resources for future use",
      "Ignoring the environment",
      "Promoting waste"
    ],
    "answer": "Preserving resources for future use"
  },
  {
    "question": "What promotes peaceful co-existence?",
    "options": [
      "Intolerance",
      "Dialogue and mutual respect",
      "Hatred",
      "Bullying"
    ],
    "answer": "Dialogue and mutual respect"
  },
  {
    "question": "How can pollution be reduced?",
    "options": [
      "Burning plastics",
      "Dumping refuse in rivers",
      "Using clean energy and proper waste disposal",
      "Overusing chemicals"
    ],
    "answer": "Using clean energy and proper waste disposal"
  },
  {
    "question": "Which factor is essential in conflict resolution?",
    "options": [
      "Blame games",
      "Violence",
      "Effective communication",
      "Ignoring each other"
    ],
    "answer": "Effective communication"
  },
  {
    "question": "What does economic development mean?",
    "options": [
      "A rise in inflation",
      "Improved standard of living and productivity",
      "A fall in exports",
      "Increased borrowing"
    ],
    "answer": "Improved standard of living and productivity"
  },
  {
    "question": "How can teenage pregnancy be reduced?",
    "options": [
      "Avoiding reproductive education",
      "Promoting abstinence and safe practices",
      "Encouraging early marriage",
      "Ignoring peer influence"
    ],
    "answer": "Promoting abstinence and safe practices"
  },
  {
    "question": "What is the main aim of national independence?",
    "options": [
      "Colonial rule",
      "Self-governance and freedom",
      "Foreign domination",
      "Loss of culture"
    ],
    "answer": "Self-governance and freedom"
  },
  {
    "question": "What is the function of rights and responsibilities?",
    "options": [
      "To limit citizens",
      "To balance freedom with accountability",
      "To suppress people",
      "To discourage laws"
    ],
    "answer": "To balance freedom with accountability"
  },
  {
    "question": "Which of the following is a developmental resource?",
    "options": [
      "Plastic waste",
      "Minerals and fertile land",
      "Pollution",
      "Refuse dumps"
    ],
    "answer": "Minerals and fertile land"
  },
  {
    "question": "What is the consequence of deforestation?",
    "options": [
      "Increased rainfall",
      "Loss of biodiversity and climate imbalance",
      "Improved farming",
      "Clean water"
    ],
    "answer": "Loss of biodiversity and climate imbalance"
  },
  {
    "question": "Why is tolerance important in democracy?",
    "options": [
      "It discourages freedom",
      "It promotes peace and mutual respect",
      "It weakens leadership",
      "It causes conflict"
    ],
    "answer": "It promotes peace and mutual respect"
  },
  {
    "question": "How can citizens support national development?",
    "options": [
      "By paying taxes and being law-abiding",
      "By avoiding social work",
      "By refusing to vote",
      "By demanding bribes"
    ],
    "answer": "By paying taxes and being law-abiding"
  },
  {
    "question": "Which factor leads to overpopulation?",
    "options": [
      "Family planning",
      "High birth rate and limited resources",
      "Better education",
      "Low health care"
    ],
    "answer": "High birth rate and limited resources"
  },
  {
    "question": "What is an example of a public institution?",
    "options": [
      "A personal house",
      "The Ghana Police Service",
      "A private business",
      "A market woman"
    ],
    "answer": "The Ghana Police Service"
  },
  {
    "question": "What does 'socio-economic' refer to?",
    "options": [
      "Only political matters",
      "Social and economic aspects of life",
      "Just family issues",
      "Only taxes"
    ],
    "answer": "Social and economic aspects of life"
  },
  {
    "question": "What is the role of innovation in entrepreneurship?",
    "options": [
      "Increases failure",
      "Boosts creativity and problem-solving",
      "Reduces sales",
      "Avoids technology"
    ],
    "answer": "Boosts creativity and problem-solving"
  },
  {
    "question": "What makes a leader effective?",
    "options": [
      "Dictatorship",
      "Accountability and vision",
      "Favoritism",
      "Unfair treatment"
    ],
    "answer": "Accountability and vision"
  },
  {
    "question": "How can you contribute to a clean environment?",
    "options": [
      "Littering the streets",
      "Planting trees and avoiding pollution",
      "Blocking gutters",
      "Burning tires"
    ],
    "answer": "Planting trees and avoiding pollution"
  },
  {
    "question": "What is the role of institutions of marriage?",
    "options": [
      "Creating single parents",
      "Promoting family unity and child upbringing",
      "Encouraging separation",
      "Breaking traditions"
    ],
    "answer": "Promoting family unity and child upbringing"
  },
  {
    "question": "Why is it important to practice good citizenship?",
    "options": [
      "To cause problems",
      "To strengthen national unity and progress",
      "To ignore duties",
      "To break laws"
    ],
    "answer": "To strengthen national unity and progress"
  },
  {
    "question": "How can individuals contribute to sustainable development?",
    "options": [
      "Wasting resources",
      "Polluting water bodies",
      "Practicing recycling and conservation",
      "Cutting down trees unnecessarily"
    ],
    "answer": "Practicing recycling and conservation"
  },
  {
    "question": "Why is national self-reliance important?",
    "options": [
      "To depend entirely on foreign aid",
      "To build local capacity and reduce dependency",
      "To isolate from the world",
      "To ignore local industries"
    ],
    "answer": "To build local capacity and reduce dependency"
  },
  {
    "question": "Which of the following is a key feature of democracy?",
    "options": [
      "One-man rule",
      "Suppression of rights",
      "Free and fair elections",
      "No political participation"
    ],
    "answer": "Free and fair elections"
  },
  {
    "question": "What is a result of responsible parenting?",
    "options": [
      "Juvenile delinquency",
      "Poor communication",
      "Well-raised and disciplined children",
      "Parental neglect"
    ],
    "answer": "Well-raised and disciplined children"
  },
  {
    "question": "What is the role of culture in society?",
    "options": [
      "Destroys traditions",
      "Gives people identity and direction",
      "Promotes confusion",
      "Encourages laziness"
    ],
    "answer": "Gives people identity and direction"
  },
  {
    "question": "Which of the following best describes socialization?",
    "options": [
      "Isolation from society",
      "Learning values and norms of a society",
      "Avoiding school",
      "Becoming antisocial"
    ],
    "answer": "Learning values and norms of a society"
  },
  {
    "question": "Which is an environmental challenge in Ghana?",
    "options": [
      "Economic growth",
      "Improved infrastructure",
      "Illegal mining (galamsey)",
      "New road construction"
    ],
    "answer": "Illegal mining (galamsey)"
  },
  {
    "question": "What does the constitution provide for a nation?",
    "options": [
      "Fashion guidelines",
      "Religious practices",
      "Legal and governance framework",
      "Cooking recipes"
    ],
    "answer": "Legal and governance framework"
  },
  {
    "question": "Why is education important to national development?",
    "options": [
      "Reduces employment",
      "Increases illiteracy",
      "Develops skilled and informed citizens",
      "Promotes superstition"
    ],
    "answer": "Develops skilled and informed citizens"
  },
  {
    "question": "What is a common cause of conflict in communities?",
    "options": [
      "Respect for laws",
      "Peace talks",
      "Misunderstanding and lack of communication",
      "Teamwork"
    ],
    "answer": "Misunderstanding and lack of communication"
  },
  {
    "question": "What is the first step in conflict resolution?",
    "options": [
      "Retaliation",
      "Ignoring issues",
      "Listening and identifying the problem",
      "Spreading false rumors"
    ],
    "answer": "Listening and identifying the problem"
  },
  {
    "question": "Which of these practices helps reduce climate change?",
    "options": [
      "Deforestation",
      "Burning waste openly",
      "Using renewable energy sources",
      "Illegal mining"
    ],
    "answer": "Using renewable energy sources"
  },
  {
    "question": "What should guide the behavior of individuals in society?",
    "options": [
      "Peer pressure",
      "National laws and personal values",
      "Revenge",
      "Greed"
    ],
    "answer": "National laws and personal values"
  },
  {
    "question": "Which of these contributes to adolescent problems?",
    "options": [
      "Open discussions with adults",
      "Access to accurate information",
      "Peer pressure and lack of guidance",
      "Parental supervision"
    ],
    "answer": "Peer pressure and lack of guidance"
  },
  {
    "question": "What is the significance of Independence Day in Ghana?",
    "options": [
      "Beginning of colonization",
      "End of elections",
      "Freedom from colonial rule",
      "Invention of cocoa"
    ],
    "answer": "Freedom from colonial rule"
  },
  {
    "question": "What is one way to reduce teenage pregnancy?",
    "options": [
      "Encouraging early marriage",
      "Avoiding reproductive education",
      "Providing sexuality education",
      "Discouraging education"
    ],
    "answer": "Providing sexuality education"
  },
  {
    "question": "What is a key responsibility of a citizen?",
    "options": [
      "Dodging duties",
      "Voting and obeying laws",
      "Refusing taxes",
      "Engaging in violence"
    ],
    "answer": "Voting and obeying laws"
  },
  {
    "question": "What does entrepreneurship encourage?",
    "options": [
      "Job losses",
      "Innovation and job creation",
      "Overpopulation",
      "Laziness"
    ],
    "answer": "Innovation and job creation"
  },
  {
    "question": "Which of the following is a cultural practice in Ghana?",
    "options": [
      "Street racing",
      "Damba Festival",
      "Election debates",
      "Parliamentary speeches"
    ],
    "answer": "Damba Festival"
  },
  {
    "question": "How can one show patriotism?",
    "options": [
      "Destroying public property",
      "Avoiding elections",
      "Serving and promoting national interest",
      "Hating leaders"
    ],
    "answer": "Serving and promoting national interest"
  },
  {
    "question": "Why is it important to manage Ghana�s natural resources well?",
    "options": [
      "To finish them quickly",
      "To ensure sustainable development",
      "To encourage misuse",
      "To depend on imports"
    ],
    "answer": "To ensure sustainable development"
  },
  {
    "question": "What is a sign of good governance?",
    "options": [
      "Corruption",
      "Transparency and accountability",
      "Dictatorship",
      "Nepotism"
    ],
    "answer": "Transparency and accountability"
  },
  {
    "question": "How can youth contribute to peacebuilding?",
    "options": [
      "Spreading false information",
      "Organizing violence",
      "Engaging in dialogue and tolerance",
      "Avoiding community service"
    ],
    "answer": "Engaging in dialogue and tolerance"
  },
  {
    "question": "What is one of the rights of Ghanaian citizens?",
    "options": [
      "Right to be corrupt",
      "Right to education",
      "Right to break laws",
      "Right to ignore duties"
    ],
    "answer": "Right to education"
  },
  {
    "question": "How does population growth affect development?",
    "options": [
      "Lowers demand for resources",
      "No effect",
      "Can strain resources and services",
      "Improves air quality"
    ],
    "answer": "Can strain resources and services"
  },
  {
    "question": "What is an example of national duty?",
    "options": [
      "Dodging taxes",
      "Voting in elections",
      "Avoiding national ID",
      "Disobeying the law"
    ],
    "answer": "Voting in elections"
  },
  {
    "question": "What is the benefit of gender equality in development?",
    "options": [
      "Promotes discrimination",
      "Limits opportunities",
      "Harnesses the potential of all genders",
      "Reduces productivity"
    ],
    "answer": "Harnesses the potential of all genders"
  },
  {
    "question": "Which is a way to preserve national culture?",
    "options": [
      "Adopting only foreign values",
      "Ignoring traditions",
      "Practicing and teaching local customs",
      "Avoiding festivals"
    ],
    "answer": "Practicing and teaching local customs"
  },
  {
    "question": "What role does the family play in socialization?",
    "options": [
      "Instills values and norms",
      "Promotes isolation",
      "Creates hatred",
      "Discourages interaction"
    ],
    "answer": "Instills values and norms"
  },
  {
    "question": "Why should students be involved in community work?",
    "options": [
      "To destroy school property",
      "To gain money",
      "To learn civic responsibility",
      "To avoid learning"
    ],
    "answer": "To learn civic responsibility"
  },
  {
    "question": "What is the role of a constitution?",
    "options": [
      "Guides legal and political governance",
      "Dictates religion",
      "Sets business prices",
      "Selects sports teams"
    ],
    "answer": "Guides legal and political governance"
  },
  {
    "question": "What can reduce school dropout rates?",
    "options": [
      "Punishment",
      "Financial support and counseling",
      "Early marriage",
      "Child labor"
    ],
    "answer": "Financial support and counseling"
  },
  {
    "question": "What does it mean to be socially responsible?",
    "options": [
      "Ignoring rules",
      "Protecting and respecting others",
      "Avoiding duties",
      "Spreading lies"
    ],
    "answer": "Protecting and respecting others"
  },
  {
    "question": "How can citizens protect the constitution?",
    "options": [
      "Breaking the law",
      "Participating in civil society and legal processes",
      "Staying uninformed",
      "Refusing to vote"
    ],
    "answer": "Participating in civil society and legal processes"
  },
  {
    "question": "What is the purpose of festivals in Ghana?",
    "options": [
      "To cause noise",
      "To forget culture",
      "To celebrate heritage and unity",
      "To promote conflict"
    ],
    "answer": "To celebrate heritage and unity"
  },
  {
    "question": "How can entrepreneurship reduce poverty?",
    "options": [
      "Increasing unemployment",
      "Creating jobs and innovation",
      "Discouraging initiative",
      "Encouraging dependence"
    ],
    "answer": "Creating jobs and innovation"
  },
  {
    "question": "What is a common characteristic of a good leader?",
    "options": [
      "Corruption",
      "Vision and accountability",
      "Deception",
      "Pride"
    ],
    "answer": "Vision and accountability"
  },
  {
    "question": "What is the impact of science and technology on national development?",
    "options": [
      "It slows development",
      "It hinders innovation",
      "It facilitates progress and modernization",
      "It replaces culture"
    ],
    "answer": "It facilitates progress and modernization"
  },
  {
    "question": "How does early exposure to civic education help adolescents?",
    "options": [
      "It confuses them",
      "It promotes irresponsible behavior",
      "It helps them become responsible citizens",
      "It leads to rebellion"
    ],
    "answer": "It helps them become responsible citizens"
  },
  {
    "question": "Which of the following best defines national identity?",
    "options": [
      "The use of foreign products",
      "Ignoring local culture",
      "A sense of belonging to a nation",
      "Changing one's citizenship"
    ],
    "answer": "A sense of belonging to a nation"
  },
  {
    "question": "Why is population data important for planning?",
    "options": [
      "It confuses leaders",
      "It helps in election rigging",
      "It guides decision-making and resource allocation",
      "It reduces efficiency"
    ],
    "answer": "It guides decision-making and resource allocation"
  },
  {
    "question": "What is one benefit of responsible sexual behavior?",
    "options": [
      "Increase in STIs",
      "Unplanned pregnancies",
      "Better reproductive health",
      "Peer pressure"
    ],
    "answer": "Better reproductive health"
  },
  {
    "question": "How can self-identity benefit adolescents?",
    "options": [
      "Makes them confused",
      "Leads to negative behavior",
      "Helps them make confident life choices",
      "Reduces their self-esteem"
    ],
    "answer": "Helps them make confident life choices"
  },
  {
    "question": "What is the role of youth in national development?",
    "options": [
      "Engaging in criminal acts",
      "Avoiding national duties",
      "Using energy and innovation to solve problems",
      "Ignoring education"
    ],
    "answer": "Using energy and innovation to solve problems"
  },
  {
    "question": "Which of the following is a benefit of peace in a nation?",
    "options": [
      "Violence and destruction",
      "Social harmony and development",
      "Lawlessness",
      "Civil unrest"
    ],
    "answer": "Social harmony and development"
  },
  {
    "question": "Which of these best defines the constitution?",
    "options": [
      "A cultural dance",
      "A recipe book",
      "A set of fundamental laws of a nation",
      "A market guide"
    ],
    "answer": "A set of fundamental laws of a nation"
  },
  {
    "question": "How does the environment affect human life?",
    "options": [
      "It has no effect",
      "Provides essential resources for survival",
      "Destroys development",
      "Reduces creativity"
    ],
    "answer": "Provides essential resources for survival"
  },
  {
    "question": "What promotes good governance?",
    "options": [
      "Corruption and injustice",
      "Transparency and rule of law",
      "Ignoring citizens' rights",
      "Dictatorship"
    ],
    "answer": "Transparency and rule of law"
  },
  {
    "question": "How does culture influence national identity?",
    "options": [
      "By erasing history",
      "By making people identical",
      "By preserving heritage and creating a sense of belonging",
      "By discouraging development"
    ],
    "answer": "By preserving heritage and creating a sense of belonging"
  },
  {
    "question": "Why should natural resources be used wisely?",
    "options": [
      "To waste them",
      "To finish them quickly",
      "To ensure future generations benefit",
      "To pollute the environment"
    ],
    "answer": "To ensure future generations benefit"
  },
  {
    "question": "What is the main aim of adolescent reproductive health education?",
    "options": [
      "Encourage child labor",
      "Promote early marriage",
      "Provide accurate health information",
      "Discourage education"
    ],
    "answer": "Provide accurate health information"
  },
  {
    "question": "Which of the following is a reason for marriage?",
    "options": [
      "To compete with friends",
      "To fulfill social and emotional needs",
      "To waste resources",
      "To escape responsibilities"
    ],
    "answer": "To fulfill social and emotional needs"
  },
  {
    "question": "What is one way individuals can protect the environment?",
    "options": [
      "Burning plastic waste",
      "Illegal mining",
      "Proper waste disposal",
      "Killing wildlife"
    ],
    "answer": "Proper waste disposal"
  },
  {
    "question": "What does socio-economic development include?",
    "options": [
      "Only sports",
      "Military training",
      "Improving quality of life and economy",
      "Building prisons"
    ],
    "answer": "Improving quality of life and economy"
  },
  {
    "question": "What is a key responsibility of a family member?",
    "options": [
      "Avoiding communication",
      "Fulfilling roles and supporting each other",
      "Ignoring house chores",
      "Quarreling daily"
    ],
    "answer": "Fulfilling roles and supporting each other"
  },
  {
    "question": "Which of these is a sustainable practice?",
    "options": [
      "Using up all resources quickly",
      "Recycling and conservation",
      "Dumping waste in rivers",
      "Burning fossil fuels excessively"
    ],
    "answer": "Recycling and conservation"
  },
  {
    "question": "What is the importance of elections in democracy?",
    "options": [
      "To create division",
      "To select leaders through citizens' choice",
      "To empower one tribe",
      "To enforce dictatorship"
    ],
    "answer": "To select leaders through citizens' choice"
  },
  {
    "question": "What is one way socialization occurs?",
    "options": [
      "Isolation",
      "Interaction with family and society",
      "Staying alone",
      "Avoiding education"
    ],
    "answer": "Interaction with family and society"
  },
  {
    "question": "What does peace building aim to achieve?",
    "options": [
      "More conflicts",
      "War",
      "Understanding and harmony",
      "Revenge"
    ],
    "answer": "Understanding and harmony"
  },
  {
    "question": "Which of the following shows responsible parenthood?",
    "options": [
      "Neglecting children",
      "Abusing children",
      "Providing for and guiding children",
      "Avoiding family duties"
    ],
    "answer": "Providing for and guiding children"
  },
  {
    "question": "What does the international community do?",
    "options": [
      "Ignore nations",
      "Support development and peace efforts",
      "Destroy local culture",
      "Impose dictatorship"
    ],
    "answer": "Support development and peace efforts"
  },
  {
    "question": "What is one way education brings societal change?",
    "options": [
      "Encouraging ignorance",
      "Spreading misinformation",
      "Raising informed citizens",
      "Limiting freedom"
    ],
    "answer": "Raising informed citizens"
  },
  {
    "question": "What can promote tolerance in society?",
    "options": [
      "Prejudice",
      "Open dialogue and understanding",
      "Hatred",
      "Discrimination"
    ],
    "answer": "Open dialogue and understanding"
  },
  {
    "question": "Why is it important to participate in community development?",
    "options": [
      "To avoid responsibilities",
      "To divide communities",
      "To help solve local problems",
      "To destroy public property"
    ],
    "answer": "To help solve local problems"
  },
  {
    "question": "What is the best way to resolve a dispute?",
    "options": [
      "Violence",
      "Dialogue and mediation",
      "Avoiding the issue",
      "Spreading rumors"
    ],
    "answer": "Dialogue and mediation"
  },
  {
    "question": "Which is an example of social responsibility?",
    "options": [
      "Refusing to vote",
      "Burning waste indiscriminately",
      "Helping to clean your community",
      "Disobeying laws"
    ],
    "answer": "Helping to clean your community"
  },
  {
    "question": "What is an effect of poor sanitation?",
    "options": [
      "Clean environment",
      "Increased diseases",
      "Healthy population",
      "More tourists"
    ],
    "answer": "Increased diseases"
  },
  {
    "question": "Which of the following helps reduce corruption?",
    "options": [
      "Lack of transparency",
      "Citizen participation and strong institutions",
      "Ignoring public officials",
      "Supporting favoritism"
    ],
    "answer": "Citizen participation and strong institutions"
  },
  {
    "question": "Which group plays a major role in cultural transmission?",
    "options": [
      "Technology",
      "Celebrities",
      "Family and community",
      "Aliens"
    ],
    "answer": "Family and community"
  },
  {
    "question": "What should youth avoid to stay productive?",
    "options": [
      "Education",
      "Skills training",
      "Drug abuse and truancy",
      "Mentorship"
    ],
    "answer": "Drug abuse and truancy"
  },
  {
    "question": "Why is obeying traffic laws important?",
    "options": [
      "To cause accidents",
      "To challenge authority",
      "To prevent road accidents",
      "To waste time"
    ],
    "answer": "To prevent road accidents"
  },
  {
    "question": "What is a key feature of sustainable development?",
    "options": [
      "Overexploitation of resources",
      "Short-term gains only",
      "Balancing needs of present and future generations",
      "Wasting resources"
    ],
    "answer": "Balancing needs of present and future generations"
  },
  {
    "question": "What is an example of civic responsibility?",
    "options": [
      "Dodging taxes",
      "Obeying laws and voting",
      "Ignoring elections",
      "Vandalism"
    ],
    "answer": "Obeying laws and voting"
  },
  {
    "question": "How can the youth engage in entrepreneurship?",
    "options": [
      "By staying idle",
      "Starting and running small businesses",
      "Avoiding innovation",
      "Complaining always"
    ],
    "answer": "Starting and running small businesses"
  },
  {
    "question": "What does followership mean in governance?",
    "options": [
      "Blind obedience to leaders",
      "Active participation and support of leaders",
      "Ignoring leadership",
      "Dictating to leaders"
    ],
    "answer": "Active participation and support of leaders"
  },
  {
    "question": "What is the main reason for educating citizens about their rights?",
    "options": [
      "To make them arrogant",
      "To increase disobedience",
      "To promote responsible citizenship",
      "To prevent voting"
    ],
    "answer": "To promote responsible citizenship"
  },
  {
    "question": "Which factor contributes most to youth unemployment?",
    "options": [
      "Too many schools",
      "Lack of relevant skills and training",
      "Overpopulation of teachers",
      "Too many roads"
    ],
    "answer": "Lack of relevant skills and training"
  },
  {
    "question": "How can family members strengthen family bonds?",
    "options": [
      "Avoiding communication",
      "Frequent misunderstandings",
      "Respect and shared responsibilities",
      "Keeping secrets"
    ],
    "answer": "Respect and shared responsibilities"
  },
  {
    "question": "What is one role of traditional authorities in Ghana?",
    "options": [
      "They organize elections",
      "They promote foreign culture",
      "They preserve customs and resolve disputes",
      "They ignore community problems"
    ],
    "answer": "They preserve customs and resolve disputes"
  },
  {
    "question": "How does education affect national development?",
    "options": [
      "By creating ignorance",
      "By delaying progress",
      "By producing skilled human resources",
      "By increasing crime"
    ],
    "answer": "By producing skilled human resources"
  },
  {
    "question": "What does socialization teach children?",
    "options": [
      "To ignore rules",
      "Cultural values and acceptable behavior",
      "To challenge elders",
      "To avoid school"
    ],
    "answer": "Cultural values and acceptable behavior"
  },
  {
    "question": "How can conflicts be prevented in communities?",
    "options": [
      "Spreading rumors",
      "Dialogue and mutual respect",
      "Favoritism",
      "Neglecting youth"
    ],
    "answer": "Dialogue and mutual respect"
  },
  {
    "question": "Which of the following is a form of responsible parenthood?",
    "options": [
      "Abandoning children",
      "Providing for and guiding children",
      "Forcing children into labor",
      "Avoiding parental duties"
    ],
    "answer": "Providing for and guiding children"
  },
  {
    "question": "What is the primary role of the constitution?",
    "options": [
      "To encourage violence",
      "To serve as a guide for governance",
      "To control religion",
      "To ignore minority rights"
    ],
    "answer": "To serve as a guide for governance"
  },
  {
    "question": "What can individuals do to support national development?",
    "options": [
      "Destroy public property",
      "Avoid paying taxes",
      "Volunteer and obey laws",
      "Spread false information"
    ],
    "answer": "Volunteer and obey laws"
  },
  {
    "question": "How does sustainable development help the economy?",
    "options": [
      "By destroying the environment",
      "By creating long-term opportunities",
      "By focusing only on profit",
      "By ignoring future generations"
    ],
    "answer": "By creating long-term opportunities"
  },
  {
    "question": "What promotes a strong national identity?",
    "options": [
      "Cultural pride and national symbols",
      "Ignoring local customs",
      "Promoting foreign languages only",
      "Forgetting history"
    ],
    "answer": "Cultural pride and national symbols"
  },
  {
    "question": "Why is child education important for the family and society?",
    "options": [
      "It wastes resources",
      "It creates laziness",
      "It equips children for responsible adulthood",
      "It delays marriage"
    ],
    "answer": "It equips children for responsible adulthood"
  },
  {
    "question": "What is one function of the Electoral Commission of Ghana?",
    "options": [
      "Appointing presidents",
      "Conducting fair and free elections",
      "Forming political parties",
      "Making laws"
    ],
    "answer": "Conducting fair and free elections"
  },
  {
    "question": "What is the benefit of proper sanitation?",
    "options": [
      "Bad odor",
      "Health and hygiene",
      "Spread of disease",
      "Blocked drainage"
    ],
    "answer": "Health and hygiene"
  },
  {
    "question": "Which of these is an obligation of citizens?",
    "options": [
      "Littering the streets",
      "Obeying the law",
      "Avoiding voting",
      "Cheating in exams"
    ],
    "answer": "Obeying the law"
  },
  {
    "question": "How can youth contribute to reducing unemployment?",
    "options": [
      "Becoming dependent on parents",
      "Creating their own jobs through entrepreneurship",
      "Waiting for government jobs only",
      "Refusing to work"
    ],
    "answer": "Creating their own jobs through entrepreneurship"
  },
  {
    "question": "What is the result of irresponsible parenting?",
    "options": [
      "Well-behaved children",
      "Neglected and undisciplined children",
      "Civic awareness",
      "Improved learning"
    ],
    "answer": "Neglected and undisciplined children"
  },
  {
    "question": "Why is science and technology vital to modern economies?",
    "options": [
      "It encourages backwardness",
      "It promotes superstition",
      "It boosts productivity and innovation",
      "It destroys infrastructure"
    ],
    "answer": "It boosts productivity and innovation"
  },
  {
    "question": "What is a key value in nation-building?",
    "options": [
      "Selfishness",
      "Patriotism",
      "Corruption",
      "Greed"
    ],
    "answer": "Patriotism"
  },
  {
    "question": "Which of the following is a role of marriage in society?",
    "options": [
      "Promoting loneliness",
      "Encouraging disunity",
      "Ensuring family continuity",
      "Destroying customs"
    ],
    "answer": "Ensuring family continuity"
  },
  {
    "question": "What is the purpose of international cooperation?",
    "options": [
      "Promoting global conflict",
      "Sharing knowledge and solving global issues",
      "Imposing culture",
      "Hiding information"
    ],
    "answer": "Sharing knowledge and solving global issues"
  },
  {
    "question": "What is self-identity?",
    "options": [
      "A brand of clothes",
      "Knowing who you are and what you stand for",
      "A social media status",
      "Someone else's opinion"
    ],
    "answer": "Knowing who you are and what you stand for"
  },
  {
    "question": "What encourages peaceful co-existence?",
    "options": [
      "Tribalism",
      "Mutual respect and understanding",
      "Ethnic division",
      "Discrimination"
    ],
    "answer": "Mutual respect and understanding"
  },
  {
    "question": "What is an example of non-formal education?",
    "options": [
      "Learning in school",
      "Watching TV shows",
      "Skills training workshops",
      "Taking exams"
    ],
    "answer": "Skills training workshops"
  },
  {
    "question": "Why is early marriage discouraged in adolescent health education?",
    "options": [
      "It promotes education",
      "It increases opportunities",
      "It often leads to health and social problems",
      "It reduces poverty"
    ],
    "answer": "It often leads to health and social problems"
  },
  {
    "question": "What should leaders prioritize?",
    "options": [
      "Personal wealth",
      "Public service and accountability",
      "Favoritism",
      "Disrespecting laws"
    ],
    "answer": "Public service and accountability"
  },
  {
    "question": "What is one result of illegal mining?",
    "options": [
      "Environmental destruction",
      "Community growth",
      "More food",
      "Clean rivers"
    ],
    "answer": "Environmental destruction"
  },
  {
    "question": "What is a key function of the family?",
    "options": [
      "Breaking laws",
      "Socializing members",
      "Promoting violence",
      "Avoiding responsibilities"
    ],
    "answer": "Socializing members"
  },
  {
    "question": "How does patriotism manifest?",
    "options": [
      "Disobeying national laws",
      "Destroying state property",
      "Serving and promoting national interests",
      "Ignoring independence"
    ],
    "answer": "Serving and promoting national interests"
  },
  {
    "question": "How does social media affect identity formation?",
    "options": [
      "It has no effect",
      "It helps shape perceptions and influences behavior",
      "It promotes critical thinking only",
      "It reduces interaction"
    ],
    "answer": "It helps shape perceptions and influences behavior"
  },
  {
    "question": "Why is national independence important?",
    "options": [
      "For continued colonization",
      "To lose sovereignty",
      "For self-governance and pride",
      "To weaken the state"
    ],
    "answer": "For self-governance and pride"
  },
  {
    "question": "What is a key benefit of resource development?",
    "options": [
      "Creating scarcity",
      "Generating employment and national revenue",
      "Increasing imports",
      "Causing pollution"
    ],
    "answer": "Generating employment and national revenue"
  },
  {
    "question": "How does peace building contribute to development?",
    "options": [
      "By promoting conflict",
      "By discouraging dialogue",
      "By creating a stable environment for growth",
      "By increasing insecurity"
    ],
    "answer": "By creating a stable environment for growth"
  },
  {
    "question": "What is one benefit of responsible citizenship?",
    "options": [
      "Ignoring national issues",
      "Promoting unity and national progress",
      "Avoiding voting",
      "Spreading rumors"
    ],
    "answer": "Promoting unity and national progress"
  },
  {
    "question": "Why is population growth a concern for development?",
    "options": [
      "It creates more leaders",
      "It can strain available resources",
      "It increases farmland",
      "It promotes technology"
    ],
    "answer": "It can strain available resources"
  },
  {
    "question": "What is one major challenge of urbanization?",
    "options": [
      "Increased rural farming",
      "Traffic congestion and poor housing",
      "Higher literacy",
      "Improved roads"
    ],
    "answer": "Traffic congestion and poor housing"
  },
  {
    "question": "Which of these promotes sustainable development?",
    "options": [
      "Overexploitation of resources",
      "Deforestation",
      "Conservation and responsible resource use",
      "Pollution"
    ],
    "answer": "Conservation and responsible resource use"
  },
  {
    "question": "What is the role of traditional festivals?",
    "options": [
      "To cause conflicts",
      "To waste resources",
      "To promote culture and unity",
      "To stop education"
    ],
    "answer": "To promote culture and unity"
  },
  {
    "question": "Which of these is an effect of illegal migration?",
    "options": [
      "Improved local economy",
      "Family reunion",
      "Loss of lives and abuse",
      "Increased tourism"
    ],
    "answer": "Loss of lives and abuse"
  },
  {
    "question": "What is one function of the United Nations?",
    "options": [
      "Spreading war",
      "Promoting international peace and security",
      "Encouraging dictatorship",
      "Controlling all countries"
    ],
    "answer": "Promoting international peace and security"
  },
  {
    "question": "How can youth support national development?",
    "options": [
      "Refusing education",
      "Engaging in volunteerism and innovation",
      "Disrespecting elders",
      "Promoting tribalism"
    ],
    "answer": "Engaging in volunteerism and innovation"
  },
  {
    "question": "Which of the following best describes leadership?",
    "options": [
      "Imposing fear",
      "Directing and inspiring others",
      "Avoiding responsibilities",
      "Following always"
    ],
    "answer": "Directing and inspiring others"
  },
  {
    "question": "How can environmental degradation be reduced?",
    "options": [
      "Ignoring waste disposal",
      "Planting trees and reducing pollution",
      "Using plastics excessively",
      "Burning forests"
    ],
    "answer": "Planting trees and reducing pollution"
  },
  {
    "question": "Which sector benefits most directly from science and technology?",
    "options": [
      "Superstition",
      "Healthcare and agriculture",
      "Gambling",
      "Myths"
    ],
    "answer": "Healthcare and agriculture"
  },
  {
    "question": "What is an example of civic responsibility?",
    "options": [
      "Cheating in elections",
      "Obeying traffic rules",
      "Refusing to vote",
      "Damaging public property"
    ],
    "answer": "Obeying traffic rules"
  },
  {
    "question": "Why should young people understand reproductive health?",
    "options": [
      "To increase teenage pregnancies",
      "To make better health decisions",
      "To encourage risky behavior",
      "To ignore relationships"
    ],
    "answer": "To make better health decisions"
  },
  {
    "question": "What does it mean to be a patriotic citizen?",
    "options": [
      "Serving and defending your country",
      "Abandoning national duties",
      "Promoting tribal conflicts",
      "Ignoring the flag"
    ],
    "answer": "Serving and defending your country"
  },
  {
    "question": "What is one cause of conflict in communities?",
    "options": [
      "Fairness and justice",
      "Discrimination and misunderstanding",
      "Unity and cooperation",
      "Equality"
    ],
    "answer": "Discrimination and misunderstanding"
  },
  {
    "question": "What helps protect children's rights in Ghana?",
    "options": [
      "Child Labour",
      "The Children's Act",
      "Neglect",
      "Abuse"
    ],
    "answer": "The Children's Act"
  },
  {
    "question": "What is the function of the judiciary in a democracy?",
    "options": [
      "To make laws",
      "To interpret and uphold laws",
      "To run elections",
      "To print money"
    ],
    "answer": "To interpret and uphold laws"
  },
  {
    "question": "Which of the following supports economic development?",
    "options": [
      "Laziness",
      "Investment in infrastructure and education",
      "Over-dependence on imports",
      "Underemployment"
    ],
    "answer": "Investment in infrastructure and education"
  },
  {
    "question": "What role does culture play in society?",
    "options": [
      "Creates confusion",
      "Gives identity and guides behavior",
      "Prevents unity",
      "Limits knowledge"
    ],
    "answer": "Gives identity and guides behavior"
  },
  {
    "question": "Which is a consequence of poor parenting?",
    "options": [
      "Moral upbringing",
      "High discipline",
      "Increased juvenile delinquency",
      "Strong family ties"
    ],
    "answer": "Increased juvenile delinquency"
  },
  {
    "question": "What is the goal of entrepreneurship?",
    "options": [
      "To promote idleness",
      "To create jobs and wealth",
      "To avoid taxes",
      "To waste resources"
    ],
    "answer": "To create jobs and wealth"
  },
  {
    "question": "How can Ghana benefit from the African Union?",
    "options": [
      "By isolating itself",
      "Through economic and political cooperation",
      "By opposing its members",
      "By breaking ties"
    ],
    "answer": "Through economic and political cooperation"
  },
  {
    "question": "What is one way individuals can help their communities?",
    "options": [
      "Avoiding communal work",
      "Volunteer service",
      "Spreading rumors",
      "Destroying public assets"
    ],
    "answer": "Volunteer service"
  },
  {
    "question": "How does education promote social mobility?",
    "options": [
      "By keeping people poor",
      "By offering opportunities for improvement",
      "By increasing illiteracy",
      "By closing schools"
    ],
    "answer": "By offering opportunities for improvement"
  },
  {
    "question": "What encourages effective governance?",
    "options": [
      "Nepotism",
      "Transparency and accountability",
      "Corruption",
      "Favoritism"
    ],
    "answer": "Transparency and accountability"
  },
  {
    "question": "Which factor is key to community development?",
    "options": [
      "Greed",
      "Unity and participation",
      "Selfishness",
      "Division"
    ],
    "answer": "Unity and participation"
  },
  {
    "question": "What is a major resource in Ghana?",
    "options": [
      "Oil and gold",
      "Sand",
      "Ice",
      "Plastic"
    ],
    "answer": "Oil and gold"
  },
  {
    "question": "How does culture affect tourism?",
    "options": [
      "It discourages visitors",
      "It attracts tourists through festivals and heritage",
      "It limits interaction",
      "It creates borders"
    ],
    "answer": "It attracts tourists through festivals and heritage"
  },
  {
    "question": "Why is communication important in the family?",
    "options": [
      "To increase tension",
      "To spread rumors",
      "To promote understanding and unity",
      "To isolate members"
    ],
    "answer": "To promote understanding and unity"
  },
  {
    "question": "What is an effect of poor sanitation?",
    "options": [
      "Health improvement",
      "Disease outbreaks",
      "Clean environment",
      "Safe water"
    ],
    "answer": "Disease outbreaks"
  },
  {
    "question": "What role do youth play in democracy?",
    "options": [
      "Fighting leaders",
      "Avoiding elections",
      "Active participation and advocacy",
      "Spreading hate"
    ],
    "answer": "Active participation and advocacy"
  },
  {
    "question": "What is a national symbol?",
    "options": [
      "Currency only",
      "National flag",
      "Textbooks",
      "TVs"
    ],
    "answer": "National flag"
  },
  {
    "question": "Why is resource management important?",
    "options": [
      "To waste resources",
      "To ensure sustainability",
      "To damage the ecosystem",
      "To avoid recycling"
    ],
    "answer": "To ensure sustainability"
  },
  {
    "question": "What is an effect of bribery and corruption?",
    "options": [
      "Development",
      "Loss of trust and poor governance",
      "Unity",
      "Strong institutions"
    ],
    "answer": "Loss of trust and poor governance"
  },
  {
    "question": "What is one advantage of modern technology in education?",
    "options": [
      "Confusion",
      "Access to global knowledge",
      "High cost only",
      "Noise"
    ],
    "answer": "Access to global knowledge"
  },
  {
    "question": "Why should Ghanaians protect their natural resources?",
    "options": [
      "To increase imports",
      "For present and future generations",
      "To destroy forests",
      "To promote mining abuse"
    ],
    "answer": "For present and future generations"
  },
  {
    "question": "What promotes peace and order?",
    "options": [
      "Disobedience",
      "Respect for laws and dialogue",
      "Violence",
      "False accusations"
    ],
    "answer": "Respect for laws and dialogue"
  },
  {
    "question": "What is the outcome of fulfilling civic duties?",
    "options": [
      "A strong and functional society",
      "Disorder",
      "Oppression",
      "Isolation"
    ],
    "answer": "A strong and functional society"
  }
];
export default socialstudiesQuestions;